// ClockInOut.js  (v3.4 — see earlier notes below)
// v3.23: month grid totals rows (Raw / Planned / Actual payroll / Overtime)
//       are now STICKY at the bottom of the scroll area, mirroring the sticky
//       header rows, so the day cells scroll between the two. Fixed 24px row
//       height per totals row with stacked bottom offsets; the label cells
//       stay pinned left as well.
// v3.22: hours are TWO DECIMAL PLACES everywhere — the shared h1() rounder
//       (exports, grid footer totals) moves from 1dp to 2dp so spreadsheets
//       match the on-screen figures exactly; the unused 1dp mm() helper in
//       the month export is removed.
// v3.21: EXPORT ALIGNMENT — every Excel output now carries the new fields.
//       Day export + month exports (one pharmacy and all pharmacies) gain
//       "Payroll o/time (h)" (override where set, else surplus on approved
//       days), "Clock-in device(s)", "Clock-out device(s)" and "Device
//       changed"; month TOTALS row sums payroll o/time; the month grid's
//       "Overtime total" footer and the Summary tab (backend v42.4) now
//       honour manual payroll-o/time overrides on approved days.
// v3.20: CellDialog widened to 1320px; month-view staff-name column headers
//       turn GREEN when every one of that member's days needing review is
//       reviewed (manually or automatically) — same rule as the dialog's
//       "Days reviewed" counter.
// v3.19: each staff-dialog row gains a small "Log" button pinned to its top
//       right (change history popup); Approved overtime ticks now also write
//       a log entry. CellDialog is ALIGNED with the row layout: "Contracted
//       hrs covered / Potential overtime" lines, "Cont hrs on payroll" and a
//       new editable "O/time hrs on payroll" + Approved, and a read-only
//       "Auto review" tick — both views now expose the same data with the
//       same labels. Both entry builders pass payrollOtHours through.
// v3.18: Manager-notes box pinned to a true square (132×54, no flex-grow) —
//       it was stretching across the flexible Review column as a wide bar.
// v3.17: Review flattened to ONE band: the two payroll lines stack on the
//       left, and to their right sit a square Manager-notes box (between
//       Approved and the review tick) and "Review complete" — removing the
//       third row and cutting row height further.
// v3.16: "Automatically reviewed" label shortened to "Auto review".
// v3.15: header stats row — "Days reviewed" moves up beside the month label,
//       followed by "Total cont hrs" (sum of the month's paid contracted
//       hours), "Payroll cont. hrs" (sum of each day's standard payroll:
//       override where set, else covered hours) and "Payroll o/time" (sum of
//       payroll overtime on days with Approved ticked). The two contracted
//       chips turn green together when they match; all live-update as saves land.
// v3.14: WIDTH CONTROL FIX — the flexible grid column was "What happened",
//       so any spare dialog width poured into it (why it kept ballooning).
//       Review is now the flexible column; What happened is pinned narrow.
//       SAVE SAFETY — failed saves now REVERT the optimistic tick/value and
//       report the server's words (a plain "Forbidden" usually means the
//       session expired — log in again). Each day gains a small "log" link
//       opening that day's change log. The Configure popup shows the live
//       four-week contracted total (per-day breaks respected).
// v3.13: "Automatically reviewed" moves under the Analysis text; in Review,
//       Manager notes moves up beside "Review complete" on one line — the
//       column is now three rows, holding row height down.
// v3.12: wider dialog (1780px), a "Days reviewed: n/N" counter at the top of
//       the day list (N = days with a plan or clockings; n = reviewed
//       manually or automatically) shown green when complete and ochre
//       otherwise, and the overtime "Approved" checkbox now also enables
//       whenever the O/time-on-payroll box holds a value.
// v3.11: staff-dialog column rebalance — "What happened" halved, "Review"
//       doubled and spread onto labelled lines: "Cont hrs on payroll"
//       (defaults to the on-site hours that satisfy the contracted figure),
//       "O/time hrs on payroll" (defaults to the surplus) with an "Approved"
//       checkbox beside it, then "Review complete" (default unticked) and a
//       read-only "Automatically reviewed" indicator.
// v3.10: staff-dialog visual tidy — the Review column was wrapping every
//       control onto its own line, stretching each row to ~300px. Review is
//       now a tight 2×2 grid (approve OT | reviewed / Std | O/T) with notes
//       beneath; consistent 12px type and 1.4 line rhythm across all
//       sections; rows top-aligned and compact (~90px typical).
// v3.9: staff-dialog polish: "Paid" label, narrower break box, break total on
//       its own line under hours on site, explanatory hover help on all four
//       validation lines, ANALYSIS shows "Contracted hrs covered" (on-site
//       hours toward paid contracted, capped) with "Potential overtime"
//       beneath, and REVIEW gains editable "Payroll std hrs" and "Payroll
//       o/time hrs" persisted per day (backend v42.3).
// v3.8: staff-dialog rows recut: FIRST CELL — "Mon 2nd" top-left, scheduled
//       from/to under it flush left, break hrs + Paid break, and the day's
//       total contracted hours (scheduled less unpaid break). Sections are
//       separated by vertical rules: ACTUAL (bigger, read-only session times
//       with each event's notes to its right, breaks beneath, totals for
//       hours on site and breaks at the foot) | VALIDATION (distances and
//       device ids stacked vertically, line background flags >50 m or a
//       changed device) | ANALYSIS | REVIEW. Rows tightened for minimal
//       height.
// v3.7: staff-dialog day rows restructured for readability: five tight
//       sections — WHAT IT SHOULD BE (editable schedule), WHAT IT IS
//       (sessions/breaks/notes), VALIDATION (distance in/out with ✓/✗ AND
//       device id in/out, red-highlighted when changed vs the previous
//       session), ANALYSIS (on-site total, potential OT, issues,
//       auto-approved), REVIEW (approve OT, reviewed, manager notes).
//       Larger base font, compact aligned grid, no dead space.
// v3.6: STAFF DIALOG v2 (month view): schedule editing moves into its own
//       "Configure scheduled hours" popup — Mon–Sun start/end each with a
//       PER-DAY break length + one paid-breaks flag; "Save pattern" writes
//       the whole pattern to every week of the month (overwriting what was
//       there). The day list is now FULL WIDTH with clear columns per day:
//       (1) SCHEDULED — planned start/end, break length, paid flag, all
//       editable inline (saves to that weekday's pattern) + potential OT;
//       (2) ACTUAL — each session's in/out and breaks with notes aligned
//       beside each; (3) DISTANCE — check-in and check-out each with ✓/✗;
//       (4) APPROVALS — auto-approved (read-only), approve overtime, mark
//       reviewed, manager notes. Rows go GREEN when approved (auto or
//       manual), OCHRE when attention is still needed. Everything auto-saves;
//       double-clicking a row still marks its review complete.
// v3.5: STAFF DIALOG REDESIGN (month view name-click): much larger two-panel
//       layout. LEFT — "Scheduled sessions": the weekly pattern editor, four
//       week total, break controls and email button (unchanged behaviour;
//       Apply buttons still write to the month). RIGHT (2/3) — every day of
//       the selected month for that staff member with the full cell analysis
//       (planned, sessions with distances/notes/devices, breaks, OT, payroll,
//       manager notes, issues, auto-confirmed) inline. Reviewed tick, OT
//       approval, payroll hours and notes AUTO-SAVE as they're changed;
//       DOUBLE-CLICKING a day marks its review complete. Rows are tinted with
//       the same status colours as the grid and patch the grid live. The Day
//       view name-click keeps the previous compact schedule-only dialog.
// v3.4: staff weekly-schedule dialogue — widened to 940px with no-wrap
//       rows so both Apply buttons sit inline right of the time inputs;
//       "Apply to all weekdays" now also updates the dialogue's own input
//       boxes (it already updated the grid behind); double-clicking either
//       time input sets that day to 09:00–18:00.
// v3.3: bulk schedule-invite UI DELETED (not just hidden); with headoffice
//       v41.1 refusing anything but a single named staffId, bulk emails to
//       staff cannot be fired from any client. Single-staff send remains.
// v3.2: schedule-invite emails split into two flags — the SINGLE-staff
//       "✉ Email schedule form to <name>" button (weekly schedule
//       dialogue) is ENABLED; the day/month "email all staff" buttons
//       remain hidden (SCHEDULE_INVITE_ALL_ENABLED = false).
// v3.1: schedule-invite emails DISABLED behind SCHEDULE_INVITES_ENABLED =
//       false (all three send buttons hidden: day view all-staff, month
//       view all-staff, single-staff in the weekly schedule dialogue).
//       Flip the flag to true to restore — backend endpoints and the
//       public form module stay deployed and functional.
// v3.0: STAFF SELF-SERVICE SCHEDULE EMAILS. Day view ("all branches") and
//       month view ("selected pharmacy") gain "✉ Email schedule forms to
//       all staff"; the staff weekly-schedule dialogue gains a single-staff
//       send. Every send shows a confirm dialog first and a result summary
//       after (sent / skipped-no-email / failed). Links (headoffice v41 +
//       staff_schedule_public.js) last 24 hours and open an interactive
//       form: view/update/submit own weekly hours, no break access, live
//       four-week contracted total.
// v2.9: "Four week contracted hours total" — four weeks of the weekly
//       pattern minus unpaid break entitlements (backend v40.1) — shown in
//       the cell dialogue (left panel), live-computed in the staff weekly
//       schedule dialogue, added to each staff tab's header in the month
//       exports and as a column in the day export.
// v2.8: MONTH VIEW — pharmacy dropdown entries carry a status background
//       (green: every recorded day approved manually or auto; red: any day
//       needing attention; no colour: nothing recorded or awaiting
//       completion) from the new /clock/month/status; and an "Export all
//       pharmacies" button producing ONE WORKBOOK PER PHARMACY for the
//       selected month (all roles, tab per staff member).
// v2.7: CLOCK DEVICE TRACKING. Sessions carry clockIn/clockOut device ids
//       (headoffice v40, both field casings read). The cell dialogue shows
//       "Clock-in device / Clock-out device" in its bottom corner; a value
//       that CHANGED versus the staff member's last recorded clocking gets
//       a red background with the previous id alongside, auto-confirmation
//       is blocked (reason shown), the grid withholds the auto-green
//       (amber until reviewed) and the hover tooltip explains why.
// v2.6: (1) "Raw hours on site" — every session's out minus in, no
//       adjustments — added as the FIRST bottom totals row on the month
//       view, as an early column (with TOTALS value) in the month export
//       (replacing the later duplicate "Hours on site (h)" column), and as
//       the first labelled totals row on the Summary tab screen + export.
//       (2) Clicking a staff member's NAME (day chip or month column
//       header, dotted underline + explanatory tooltip) opens a WEEKLY
//       SCHEDULE dialogue: Mon–Sun rows of scheduled start/end from
//       staff_times (new /clock/times/get), per-row "Apply to <Wd>s for
//       whole of month" and confirm-guarded "Apply to all weekdays for
//       whole of month", with Break length + Paid break saved along.
// v2.5: PAYROLL TOTALS EVERYWHERE. Month view bottom rows are now
//       "Planned hrs total:", "Actual payroll hours total:" and "Overtime
//       total:" (approved days only, net rule), all computed with the
//       shared dayCalc() that mirrors the cell dialogue. Summary tab gains
//       a Payroll measure (backend v38 payrollH) and the SAME three
//       labelled totals rows per column, on screen and in its export. Day
//       and month exports expanded to the FULL numeric set per episode:
//       contracted times, hours to be on site, break entitlement, breaks
//       paid, paid contracted, sessions, distances + >50m flag, hours on
//       site, break time taken, payroll hours, potential OT, OT approved,
//       event reviewed, auto-confirmed, manager + session notes; month
//       TOTALS row carries planned/on-site/breaks/payroll/approved-OT.
// v2.4.1: payroll default corrected — total hours on site LESS total break
//         time TAKEN when breaks are unpaid (nothing deducted when paid),
//         then capped at paid contracted hrs; potential overtime is the
//         surplus of that net figure.
// v2.4: PAYROLL ARITHMETIC. Left panel: "Hours to be on site" (end minus
//       start), editable "Break entitlement (hrs)" + "Paid?" checkbox
//       (default unpaid), and read-only "Paid contracted hrs" = on-site
//       hours minus the break entitlement ONLY when unpaid. Right panel:
//       "Hours to go on payroll sheet" now defaults LIVE to total hours on
//       site capped at paid contracted hrs (manual override still allowed
//       and logged); the surplus above paid contracted is the "Potential
//       overtime", exposed with its Approved checkbox when over 0.2h.
// v2.3: LEFT panel gains "Break length of xx hrs" (fractions) with a
//       "Breaks paid? yes/no" choice (default no) shown when >0 — stored on
//       the staff_times pattern (headoffice v37.1) and included in the
//       save/copy actions. MIDDLE panel: labelled "Notes (clock in/out)"
//       rows on every session, a Breaks section ("Break from xx to yy"),
//       and two totals — hours on site and break time taken. RIGHT panel:
//       "Contracted hours for payroll" renamed "Hours to go on payroll
//       sheet".
// v2.2: THREE-PANEL CellDialog (day + month): (1) staff/role + contracted
//       times with "Save for every <weekday>" and confirm-guarded "Copy to
//       all days ..." for one staff or ALL staff (buttons appear on change,
//       vanish after the confirmation message); (2) all sessions with
//       per-event notes and distances + total actual hours; (3) summary —
//       covered ✓/✗, editable "Contracted hours for payroll" (logged),
//       "Potential overtime of x hours" + Accept checkbox when excess >30m,
//       manager notes, LOG button (audit popup from staff_event_reviews),
//       "Review complete" tick. Review complete OR auto-confirmed (clean,
//       complete, no OT possibility) now paint the cell GREEN; blue retired.
//       Backend v37.
// v2.1: SHARED CellDialog — the full day-analysis dialogue (analysis rows,
//       overtime tick, event-review tick + manager notes, planned-hours
//       pattern editor) is now one component used by BOTH tabs: click a
//       month cell, or DOUBLE-CLICK a staff chip on the day view. The day
//       endpoint (headoffice v36.1) now returns breaks so both dialogues
//       are identical. Optimistic patches update whichever view is open.
// v2.0: SINGLE-STATUS CELL COLOURS replace the split halves — green (clean
//       & complete: on-time in, out between planned end and +10 min where
//       known, distances <50m, no notes), amber (clean, still clocked in),
//       red (any factor wrong, or planned-but-absent), BLUE when a manager
//       ticks the NEW "Event reviewed and approved" checkbox on the cell
//       analysis (persisted in staff_event_reviews, headoffice v35);
//       reviewed cells also show "✔ reviewed" and both exports gain an
//       "Event reviewed" column. THREE NEW TABS moved in from the left
//       menu: Workforce planner (real pharmacy names), Raw data
//       (stafflogin list, reverse-chronological, pharmacy/staff/search/
//       problems filters), Pharmacist rota.
// v1.4: CLOCK DISTANCES (headoffice v34). Sessions carry distIn/distOut
//       (metres from the pharmacy). Shown in cell tooltips and in the
//       month view's day-analysis dialogue ("Distance from pharmacy" row);
//       any session beyond 50m outlines the cell RED in BOTH the day and
//       month views (background halves unchanged) and flags "⚠". Day and
//       month exports gain "Distance in (m)" / "Distance out (m)" and a
//       ">50m flag" column.
// v1.2: OVERTIME = day's hours on site minus contracted hours when known
//       (whole worked day when no contracted hours) — computed server-side
//       per cell (headoffice v33). Cells with an excess get a BLUE right
//       half and an "OT xh" badge with tick state. Clicking a cell now
//       opens the FULL DAY ANALYSIS: contracted vs actual times, minutes
//       late arriving, early/late leaving, breaks and the overtime
//       arithmetic — with a "count this overtime" CHECKBOX (persisted in
//       tenant staff_overtime_approvals). The bottom overtime total shows
//       ONLY the ticked cells per column, and the export matches. The
//       planned-hours pattern editor lives on in the same dialogue.
//       "Refresh now" buttons added beside Export on Month and Summary.
// v1.3: EXPORT RESTRUCTURE — day view exports ONE TAB PER PHARMACY
//       (abbreviated pharmacy name as the tab label, per-tab header block,
//       Pharmacy column dropped as redundant); month view exports ONE TAB
//       PER STAFF MEMBER with the parameters split into columns —
//       Contracted / Actual / Breaks / Overtime (h) / Overtime approved /
//       Notes — and a TOTALS bottom row (contracted, on-site, breaks, all
//       calculated overtime, and the ticked-overtime figure).
// v1.1: Day-view arrival colours are HALF-cell (left half): green when
//       clocked in on time OR with no planned hours; amber late; red when
//       overdue and absent — right half stays white until clock-out.
//       Departure with no planned end now shows green (nothing breached).
//       Day view gains a working Refresh button. Month grid TRANSPOSED:
//       days run vertically, staff (grouped under role headers) across,
//       totals as four bottom rows; export matches the new orientation.
// -----------------------------------------------------------------------------
// Head-office "Clock in/out" panel — full-screen view opened from the Staff
// group on the dashboard. Three tabs:
//   1. Day view    — rows are branches, columns are staff grouped by role,
//                    for a chosen date. Cell colour tells the story at a
//                    glance (red = should be in but isn't; amber = late;
//                    green = on time; split halves when clocked out too).
//   2. Month view  — one pharmacy, one month; every staff member's day
//                    cells with sessions, notes and breaks; planned hours
//                    editable per weekday-occurrence (writes staff_times);
//                    per-staff totals at the bottom.
//   3. Summary     — pharmacy x role totals for a year/month window, with
//                    selectable measures (contracted / on site / overtime).
// All tabs export the currently displayed dataset to Excel (SheetJS).
// Data comes from headoffice.js v32 /api/headoffice/clock/* (JWT-scoped:
// the org comes from the token, like every other head-office module).
// -----------------------------------------------------------------------------

import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import Workforce from "./Workforce";
import Stafflogin from "./stafflogin";
import PharmacistRota from "./PharmacistRota";

const API = "https://api.pharmacegroup.co.uk";

function authToken() {
  return localStorage.getItem("token") || localStorage.getItem("authToken") || localStorage.getItem("jwt") || "";
}
async function post(path, body) {
  const r = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken()}` },
    body: JSON.stringify(body || {})
  });
  const d = await r.json();
  if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`);
  return d;
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// Clocking further than this from the pharmacy flags the cell in red.
const DIST_LIMIT_M = 50;
const distText = (m) => (m === null || m === undefined) ? "" : (m >= 1000 ? `${Math.round(m / 100) / 10}km` : `${m}m`);
const dmy = (iso) => { const [y, m, d] = String(iso || "").split("-"); return d ? `${d}/${m}/${y}` : String(iso || ""); };
const farSession = (s) => (s.distIn != null && s.distIn > DIST_LIMIT_M) || (s.distOut != null && s.distOut > DIST_LIMIT_M);
const anyFar = (sessions) => (sessions || []).some(farSession);
const distPair = (s) => {
  const parts = [];
  if (s.distIn != null) parts.push(`in ${distText(s.distIn)}${s.distIn > DIST_LIMIT_M ? " ⚠" : ""}`);
  if (s.distOut != null) parts.push(`out ${distText(s.distOut)}${s.distOut > DIST_LIMIT_M ? " ⚠" : ""}`);
  return parts.join(", ");
};
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const hm = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
const plannedDate = (dateStr, hhmm) => new Date(`${dateStr}T${hhmm}:00`);

// ---- colour rules (v2.0 single-status scheme) --------------------------------
// One background colour tells the whole story of the day's clocking event:
//   GREEN  — clean and complete: arrived no later than the planned start,
//            left no earlier than the planned end and no more than 10 min
//            after it (where planned times are known), both clock distances
//            under 50m (where recorded), and no notes.
//   AMBER  — clean so far but incomplete (still clocked in / no clock-out).
//   RED    — something needs attention: late in, left early, left more than
//            10 min after the planned end, either distance over 50m, any
//            notes, or planned to be in but absent once the start has passed.
//   BLUE   — "Event reviewed and approved" ticked by a manager: overrides
//            the computed colour so checked red cells stand out as handled.
//   blank  — nothing to say (no data, or not yet due).
const C = {
  green: "#bbf7d0", amber: "#fde68a", red: "#fecaca",
  blue: "#93c5fd", blank: "#ffffff", off: "#f8fafc"
};
const LATE_OUT_GRACE_MIN = 10;
function cellIssues(dateStr, planned, sessions) {
  // Returns the list of reasons a cell is RED (empty list = clean).
  const issues = [];
  const withIn = (sessions || []).filter(s => s.in);
  const firstIn = withIn.length ? withIn[0].in : null;
  const outs = (sessions || []).filter(s => s.out).map(s => s.out).sort();
  const lastOut = outs.length ? outs[outs.length - 1] : null;
  const stillIn = (sessions || []).some(s => s.in && !s.out);
  if (planned && planned.start && firstIn && new Date(firstIn) > plannedDate(dateStr, planned.start)) issues.push("arrived late");
  if (planned && planned.end && lastOut && !stillIn) {
    const end = plannedDate(dateStr, planned.end);
    if (new Date(lastOut) < end) issues.push("left early");
    if (new Date(lastOut) > new Date(end.getTime() + LATE_OUT_GRACE_MIN * 60000)) issues.push(`left more than ${LATE_OUT_GRACE_MIN} min late`);
  }
  if ((sessions || []).some(farSession)) issues.push(`clocked more than ${DIST_LIMIT_M}m from the pharmacy`);
  if ((sessions || []).some(s => s.inNotes || s.outNotes)) issues.push("has notes");
  return issues;
}
// Full per-day payroll arithmetic (mirrors the CellDialog): contracted,
// break entitlement, paid contracted, on-site, breaks taken, net actual,
// payroll hours (stored override wins, else net capped at paid contracted)
// and net-rule potential overtime. All figures minutes unless suffixed H.
function dayCalc(dateStr, cell) {
  const pl = cell?.planned || null;
  const sessions = cell?.sessions || [];
  const breaks = cell?.breaks || [];
  let contractedM = 0;
  if (pl && pl.start && pl.end) {
    const [sh, sm] = pl.start.split(":").map(Number), [eh, em] = pl.end.split(":").map(Number);
    contractedM = Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
  }
  const breakEntM = pl && Number.isFinite(Number(pl.breakMins)) ? Number(pl.breakMins) : 0;
  const breaksPaid = pl?.breaksPaid === true;
  const paidContractedM = contractedM > 0 ? Math.max(0, contractedM - (breaksPaid ? 0 : breakEntM)) : 0;
  let actualM = 0;
  for (const s of sessions) if (s.in && s.out) actualM += Math.max(0, (new Date(s.out) - new Date(s.in)) / 60000);
  const breakTakenM = breaks.reduce((t, b) => t + (b.mins || 0), 0);
  const netActualM = Math.max(0, actualM - (breaksPaid ? 0 : breakTakenM));
  const payrollAutoM = Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM);
  const payrollM = cell?.payrollHours != null ? Math.round(cell.payrollHours * 60) : payrollAutoM;
  const potOtM = Math.max(0, netActualM - (paidContractedM > 0 ? paidContractedM : netActualM));
  const stillIn = sessions.some(s => s.in && !s.out);
  const deviceChanged = !!(cell?.deviceChangedIn || cell?.deviceChangedOut);
  const autoConf = autoConfirmed(dateStr, pl, sessions, potOtM, deviceChanged);
  return { contractedM, breakEntM, breaksPaid, paidContractedM, actualM, breakTakenM, netActualM, payrollM, potOtM, stillIn, autoConf, deviceChanged };
}
const h1 = (mins) => Math.round(mins / 0.6) / 100;   // hours to 2dp everywhere
// Payroll overtime for one day: the manual o/time override where set, else
// the net-rule surplus — counted only when the overtime is APPROVED.
const payrollOtM = (cell, potOtM) => {
  if (!cell?.overtimeApproved) return 0;
  return cell?.payrollOtHours != null ? Math.round(cell.payrollOtHours * 60) : Math.max(0, potOtM);
};

// A day is AUTO-CONFIRMED when it needs no human attention at all: no
// issues (on time in/out, distances fine, no notes), fully clocked out, and
// no overtime possibility beyond 30 minutes.
function autoConfirmed(dateStr, planned, sessions, overtimeMins, deviceChanged) {
  // A clock-in/out DEVICE change since the last recorded day always blocks
  // auto-confirmation — a manager must review the day explicitly.
  if (deviceChanged) return false;
  if (!(sessions || []).length) return false;
  if (sessions.some(s => s.in && !s.out) || !sessions.some(s => s.out)) return false;
  if (cellIssues(dateStr, planned, sessions).length) return false;
  return !((overtimeMins || 0) > 30);
}
function cellStatus(dateStr, planned, sessions, eventReviewed, now = new Date(), deviceChanged = false) {
  // v2.2: "Review complete" turns the cell GREEN (not blue) — and a clean,
  // complete day is auto-confirmed green without any tick.
  // v2.7: a clock-device change withholds the auto-green — the cell stays
  // amber until a manager marks the review complete.
  if (eventReviewed) return C.green;
  if (deviceChanged && (sessions || []).length && !cellIssues(dateStr, planned, sessions).length) return C.amber;
  const any = (sessions || []).length > 0;
  if (!any) {
    if (planned && planned.start && now > plannedDate(dateStr, planned.start)) return C.red; // should be in but isn't
    return C.blank;
  }
  if (cellIssues(dateStr, planned, sessions).length) return C.red;
  const stillIn = sessions.some(s => s.in && !s.out) || !sessions.some(s => s.out);
  return stillIn ? C.amber : C.green;
}
function cellTooltip(planned, sessions, breaks, overtimeMins, dateStr, eventReviewed, reviewNotes, extra) {
  const lines = [];
  for (const s of sessions) {
    lines.push(`In ${hm(s.in) || "—"}${s.out ? `  Out ${hm(s.out)}` : "  (still clocked in)"}`);
    const dp = distPair(s);
    if (dp) lines.push(`  Distance: ${dp}`);
    if (s.inNotes) lines.push(`  In note: ${s.inNotes}`);
    if (s.outNotes) lines.push(`  Out note: ${s.outNotes}`);
  }
  if (dateStr) {
    const issues = cellIssues(dateStr, planned, sessions);
    if (issues.length) lines.push(`⚠ ${issues.join("; ")}`);
  }
  if (eventReviewed) lines.push("✔ Review complete (manager)");
  if (extra?.deviceChanged) lines.push("⚠ Clocking device changed since previous record — auto-confirmation withheld");
  if (reviewNotes) lines.push(`Manager note: ${reviewNotes}`);
  if (breaks && breaks.length) {
    for (const b of breaks) lines.push(`Break ${hm(b.start)}–${b.end ? hm(b.end) : "…"} (${b.mins || 0}m)`);
  }
  if (planned && (planned.start || planned.end)) lines.push(`Planned ${planned.start || "?"}–${planned.end || "?"}`);
  if (overtimeMins > 0) lines.push(`Overtime: ${Math.floor(overtimeMins / 60)}h ${overtimeMins % 60}m (on site beyond contracted) — click for full analysis`);
  return lines.join("\n");
}
function sessionsText(sessions) {
  if (!sessions.length) return "—";
  return sessions.map(s => `${hm(s.in) || "?"}${s.out ? `–${hm(s.out)}` : "–…"}`).join(", ");
}

// ---- shared bits -----------------------------------------------------------
const S = {
  btn: (c = "#0f766e") => ({ border: `1px solid ${c}`, color: c, background: "#fff", borderRadius: 4, padding: "6px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }),
  lab: { fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.3 },
  inp: { fontSize: 13, padding: "5px 8px", border: "1px solid #9ca3af", borderRadius: 4, fontFamily: "inherit" }
};

function RoleChecks({ roles, active, setActive }) {
  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
      <span style={S.lab}>Roles:</span>
      {roles.map(r => (
        <label key={r} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}>
          <input type="checkbox" checked={active.has(r)}
            onChange={e => setActive(prev => {
              const n = new Set(prev);
              if (e.target.checked) n.add(r); else n.delete(r);
              return n;
            })} />
          {r}
        </label>
      ))}
      {roles.length > 1 && (
        <button style={{ ...S.btn("#6b7280"), padding: "2px 8px", fontSize: 11 }}
          onClick={() => setActive(new Set(roles))}>All</button>
      )}
    </div>
  );
}

// Excel sheet-name rules: max 31 chars, no [ ] : * ? / \ — abbreviate and
// de-duplicate (two long names can collide after truncation).
function sheetNameFor(raw, used) {
  let base = String(raw || "Sheet").replace(/[\[\]:*?\/\\]/g, "").trim().slice(0, 31) || "Sheet";
  let name = base, n = 2;
  while (used.has(name.toLowerCase())) {
    const suffix = ` (${n++})`;
    name = base.slice(0, 31 - suffix.length) + suffix;
  }
  used.add(name.toLowerCase());
  return name;
}
function buildSheet(rows, headerLines) {
  const ws = headerLines.length
    ? XLSX.utils.aoa_to_sheet([...headerLines.map(l => [l]), []])
    : XLSX.utils.json_to_sheet(rows);
  if (headerLines.length) XLSX.utils.sheet_add_json(ws, rows, { origin: `A${headerLines.length + 2}` });
  const cols = Object.keys(rows[0] || {}).map((k, i) => ({
    wch: Math.min(46, Math.max(
      k.length,
      i === 0 ? Math.max(0, ...headerLines.map(l => Math.min(l.length, 46))) : 0,
      ...rows.map(r => String(r[k] ?? "").length)) + 2)
  }));
  ws["!cols"] = cols;
  return ws;
}
// One tab per entry: [{ name, headerLines, rows }]
function exportWorkbook(sheets, fileName) {
  const wb = XLSX.utils.book_new();
  const used = new Set();
  for (const s of sheets) {
    XLSX.utils.book_append_sheet(wb, buildSheet(s.rows, s.headerLines || []), sheetNameFor(s.name, used));
  }
  XLSX.writeFile(wb, fileName);
}
function exportSheet(rows, sheetName, fileName, headerLines = []) {
  exportWorkbook([{ name: sheetName, headerLines, rows }], fileName);
}
const generatedStamp = () => `Generated: ${new Date().toLocaleString("en-GB")}`;
const orgLine = () => localStorage.getItem("organisationName") || "";

const Legend = () => (
  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 12, color: "#374151", alignItems: "center" }}>
    {[["Auto-confirmed (clean & complete) or review complete", C.green],
      ["Clean, still clocked in", C.amber],
      [`Needs attention — late in, left early / >${LATE_OUT_GRACE_MIN} min late out, >${DIST_LIMIT_M}m away, notes, or absent`, C.red]]
      .map(([t, c]) => (
        <span key={t} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{ width: 14, height: 14, background: c, border: "1px solid #d1d5db", borderRadius: 3, display: "inline-block" }} />{t}
        </span>
      ))}
    <span style={{ color: "#6b7280" }}>Hover a cell for the detail; click a month cell for the full analysis and the approval ticks.</span>
  </div>
);

/* ============================================================================
   Shared cell analysis dialogue — used by BOTH the day view (double-click a
   staff chip) and the month view (click a cell). Shows the full day
   analysis, the overtime and event-review ticks with manager notes, and the
   planned-hours pattern editor.
   Props:
     dbName        tenant of the pharmacy the entry belongs to
     entry         { staffId, staffName, date 'YYYY-MM-DD', weekday,
                     occurrence, planned, sessions, breaks, overtimeMins,
                     overtimeApproved, eventReviewed, reviewNotes }
     onLocalPatch  (fields) => void — optimistic update of the host view
     onReload      () => Promise — full refresh (fallback + after saves)
     onClose       () => void
   ============================================================================ */
// Feature flags: staff self-service schedule emails. The SINGLE-staff send
// (inside the weekly schedule dialogue opened from a staff member's name)
// is live. Bulk "email all staff" was REMOVED entirely — its UI code is
// gone from this file and the backend (headoffice v41.1) refuses any
// request that is not exactly one named staff member, so bulk sends
// cannot be triggered from anywhere.
const SCHEDULE_INVITE_SINGLE_ENABLED = true;

// Send self-service schedule form emails (24h tokenised links) with a
// confirmatory dialog before sending and a result summary after.
async function sendScheduleInvites({ dbName, staffIds, label }) {
  if (!window.confirm(`Email an interactive schedule form (24-hour link) to ${label}?`)) return;
  try {
    const r = await post("/api/headoffice/clock/schedule/invite", { dbName, staffIds });
    const parts = [`✔ ${r.sent} email${r.sent === 1 ? "" : "s"} sent.`];
    if (r.skippedNoEmail?.length) parts.push(`Skipped (no email address): ${r.skippedNoEmail.join(", ")}.`);
    if (r.failed?.length) parts.push(`Failed: ${r.failed.join(", ")}.`);
    window.alert(parts.join("\n"));
  } catch (e) { window.alert(`Could not send: ${e.message}`); }
}

/* Weekly schedule editor — opened by clicking a staff member's NAME on the
   day or month view. One row per weekday Monday..Sunday showing the stored
   pattern; editing a row exposes "Apply to <Weekday>s for whole of month"
   (that weekday, occurrences 1-5) and "Apply to all weekdays for whole of
   month" (every day). Break length + Paid break at the bottom ride along
   with every save. */
function StaffScheduleDialog({ dbName, staffId, staffName, roleName, onReload, onClose,
                               monthDays, cellsForStaff, monthLabel, fourWeekContractedH, onCellPatch }) {
  const monthMode = Array.isArray(monthDays) && monthDays.length > 0;
  const [showPattern, setShowPattern] = useState(false);
  const WD_ORDER = [1, 2, 3, 4, 5, 6, 0]; // Monday..Sunday
  const WD_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const [rows, setRows] = useState(null);        // weekday -> {start,end}
  const [dirtyWd, setDirtyWd] = useState(new Set());
  const [breakH, setBreakH] = useState("0");
  const [breaksPaid, setBreaksPaid] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const d = await post("/api/headoffice/clock/times/get", { dbName, staffId });
        const byWd = {};
        for (const t of d.times || []) {
          if (byWd[t.weekday]) continue; // first occurrence represents the pattern
          byWd[t.weekday] = { start: t.start || "", end: t.end || "" };
          if (t.breakMins) setBreakH(String(Math.round((t.breakMins / 60) * 100) / 100));
          if (t.breaksPaid) setBreaksPaid(true);
        }
        const r = {};
        for (const wd of WD_ORDER) r[wd] = byWd[wd] || { start: "", end: "" };
        setRows(r);
      } catch (e) { setErr(e.message); setRows({}); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbName, staffId]);

  const edit = (wd, field, value) => {
    setRows(r => ({ ...r, [wd]: { ...r[wd], [field]: value } }));
    setDirtyWd(s => new Set([...s, wd]));
    setMsg(null);
  };
  const breakPayload = () => ({ breakMins: Math.round(Number(breakH || 0) * 60), breaksPaid });
  const applyWeekday = async (wd) => {
    setBusy(true); setErr(null);
    try {
      await post("/api/headoffice/clock/times/set", {
        dbName, staffId, weekday: wd, occurrences: [1, 2, 3, 4, 5],
        start: rows[wd].start || null, end: rows[wd].end || null, ...breakPayload()
      });
      await post("/api/headoffice/clock/event/review", {
        dbName, staffId, date: new Date().toISOString().slice(0, 10),
        log: [`Weekly schedule: ${WEEKDAYS[wd]}s set to ${rows[wd].start || "—"}–${rows[wd].end || "—"} via staff dialogue`]
      }).catch(() => {});
      setDirtyWd(s => { const n = new Set(s); n.delete(wd); return n; });
      setMsg(`✔ Applied to every ${WEEKDAYS[wd]} of the month`);
      await onReload();
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  const applyAll = async (wd) => {
    if (!window.confirm(`Apply ${rows[wd].start || "—"}–${rows[wd].end || "—"} to EVERY weekday of the month for ${staffName}?`)) return;
    setBusy(true); setErr(null);
    try {
      await post("/api/headoffice/clock/times/copy", {
        dbName, staffId, start: rows[wd].start || null, end: rows[wd].end || null, scope: "staff", ...breakPayload()
      });
      // reflect the applied times into every row of THIS dialogue too
      const applied = { start: rows[wd].start || "", end: rows[wd].end || "" };
      setRows(r => { const n = { ...r }; for (const w2 of WD_ORDER) n[w2] = { ...applied }; return n; });
      setDirtyWd(new Set());
      setMsg("✔ Applied to all weekdays for the whole month");
      await onReload();
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  /* ---------------- schedule panel (shared by both layouts) ---------------- */
  const schedulePanel = (
    <>
      {err && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 8 }}>{err}</div>}
      {msg && <div style={{ color: "#15803d", fontSize: 13, fontWeight: 700, marginBottom: 8 }}>{msg}</div>}
      {rows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading schedule…</div>}
      {rows !== null && WD_ORDER.map(wd => (
        <div key={wd} style={{ display: "flex", alignItems: "center", gap: 8, borderBottom: "1px solid #f1f5f9", padding: "6px 0", flexWrap: monthMode ? "wrap" : "nowrap" }}>
          <div style={{ width: 78, minWidth: 78, fontWeight: 700, fontSize: 13 }}>{WD_FULL[wd]}</div>
          <input type="time" style={S.inp} value={rows[wd]?.start || ""} onChange={e => edit(wd, "start", e.target.value)}
            title="Double-click to set 09:00–18:00"
            onDoubleClick={() => { edit(wd, "start", "09:00"); edit(wd, "end", "18:00"); }} />
          <span style={{ color: "#9ca3af" }}>–</span>
          <input type="time" style={S.inp} value={rows[wd]?.end || ""} onChange={e => edit(wd, "end", e.target.value)}
            title="Double-click to set 09:00–18:00"
            onDoubleClick={() => { edit(wd, "start", "09:00"); edit(wd, "end", "18:00"); }} />
          {dirtyWd.has(wd) && (
            <>
              <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none", whiteSpace: "nowrap", padding: "5px 9px", fontSize: 12 }}
                disabled={busy} onClick={() => applyWeekday(wd)}>
                Apply to {WEEKDAYS[wd]}s for whole of month
              </button>
              <button style={{ ...S.btn("#0f766e"), whiteSpace: "nowrap", padding: "5px 9px", fontSize: 12 }}
                disabled={busy} onClick={() => applyAll(wd)}>
                Apply to all weekdays for whole of month
              </button>
            </>
          )}
        </div>
      ))}
      <div style={{ marginTop: 12, fontSize: 13.5, fontWeight: 700 }}
           title="Four weeks of the pattern above: each scheduled day's hours minus the break entitlement when the break is unpaid, times four. Updates live as you edit.">
        Four week contracted hours total: {(() => {
          let weeklyM = 0;
          for (const wd of WD_ORDER) {
            const r = rows?.[wd];
            if (!r || !r.start || !r.end) continue;
            const [sh, sm] = r.start.split(":").map(Number), [eh, em] = r.end.split(":").map(Number);
            let m = Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
            if (!breaksPaid) m = Math.max(0, m - Math.round(Number(breakH || 0) * 60));
            weeklyM += m;
          }
          return `${((weeklyM * 4) / 60).toFixed(2)}h`;
        })()}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 12, flexWrap: "wrap" }}>
        <div><div style={S.lab}>Break length (hrs)</div>
          <input type="number" min="0" step="0.25" value={breakH}
            onChange={e => { setBreakH(e.target.value); setMsg(null); }} style={{ ...S.inp, width: 80 }} /></div>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer", paddingTop: 14 }}>
          <input type="checkbox" checked={breaksPaid} onChange={e => { setBreaksPaid(e.target.checked); setMsg(null); }} />
          Paid break?
        </label>
        <div style={{ fontSize: 11.5, color: "#9ca3af", paddingTop: 14 }}>Saved with every Apply.</div>
      </div>
      {SCHEDULE_INVITE_SINGLE_ENABLED && (
        <button style={{ ...S.btn("#3730a3"), marginTop: 14 }}
          title="Emails this staff member a personal link (valid 24 hours) to view, update and submit their own weekly schedule — breaks stay manager-only; the form shows their four-week contracted total."
          onClick={() => sendScheduleInvites({ dbName, staffIds: [staffId], label: staffName })}>
          ✉ Email schedule form to {staffName}
        </button>
      )}
    </>
  );

  /* --------------- legacy compact layout (Day view name-click) --------------- */
  if (!monthMode) return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9550 }}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(940px, 96vw)", maxHeight: "92vh", overflowY: "auto", padding: 18 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 }}>
          <div style={{ fontWeight: 800, fontSize: 15 }}>{staffName}</div>
          <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
        </div>
        <div style={{ fontSize: 12.5, color: "#6b7280", marginBottom: 10 }}>{roleName || "—"} — weekly scheduled hours</div>
        {schedulePanel}
      </div>
    </div>
  );

  /* ------------- month layout: full-width day list + pattern popup ------------- */
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9550 }}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(1780px, 98vw)", height: "92vh", display: "flex", flexDirection: "column", padding: 0, overflow: "hidden" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, padding: "12px 18px 10px", borderBottom: "1px solid #e5e7eb", flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <span style={{ fontWeight: 800, fontSize: 16 }}>{staffName}</span>
            <span style={{ fontSize: 12.5, color: "#6b7280" }}>{roleName || "—"}{monthLabel ? ` — ${monthLabel}` : ""}</span>
            {(() => {
              const cells = cellsForStaff || {};
              const hrs2 = (m) => (Math.round((m / 60) * 100) / 100).toFixed(2);
              let need = 0, done = 0, contM = 0, payM = 0, otM = 0;
              for (const dd of monthDays) {
                const cc = cells[dd.date] || {};
                const calc2 = dayCalc(dd.date, cc);
                contM += calc2.paidContractedM;
                const coveredM = Math.min(calc2.netActualM, calc2.paidContractedM > 0 ? calc2.paidContractedM : calc2.netActualM);
                payM += cc.payrollHours != null ? Math.round(cc.payrollHours * 60) : coveredM;
                if (cc.overtimeApproved) otM += cc.payrollOtHours != null ? Math.round(cc.payrollOtHours * 60) : calc2.potOtM;
                const pl = cc.planned || null, ss = cc.sessions || [];
                if (!ss.length && !pl) continue;
                need++;
                if (cc.eventReviewed || calc2.autoConf) done++;
              }
              const all = need > 0 && done === need;
              const match = hrs2(contM) === hrs2(payM);
              const chip = (bg, col, bord) => ({ fontSize: 12.5, fontWeight: 800, padding: "3px 10px", borderRadius: 5,
                background: bg, color: col, border: `1px solid ${bord}`, whiteSpace: "nowrap" });
              const grey = chip("#f3f4f6", "#374151", "#e5e7eb");
              const green = chip("#dcfce7", "#15803d", "#86efac");
              return (
                <>
                  <span style={all ? green : chip("#fde68a", "#92400e", "#f59e0b")}
                        title="Days with a schedule or clockings that are reviewed (automatically or manually) out of all days requiring review this month.">
                    Days reviewed: {done}/{need}
                  </span>
                  <span style={match ? green : grey}
                        title="The month's paid contracted hours: each scheduled day's hours less its break when unpaid, summed.">
                    Total cont hrs: {hrs2(contM)}
                  </span>
                  <span style={match ? green : grey}
                        title="Each day's standard payroll hours summed: the manual override where set, otherwise on-site hours capped at contracted. Green (with Total cont hrs) when the two match.">
                    Payroll cont. hrs: {hrs2(payM)}
                  </span>
                  <span style={chip("#eff6ff", "#1d4ed8", "#bfdbfe")}
                        title="Payroll overtime summed over days where Approved is ticked: the manual o/time override where set, otherwise the day's potential overtime.">
                    Payroll o/time: {hrs2(otM)}
                  </span>
                </>
              );
            })()}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none", fontWeight: 700 }}
              onClick={() => setShowPattern(true)}>
              Configure scheduled hours
            </button>
            {SCHEDULE_INVITE_SINGLE_ENABLED && (
              <button style={S.btn("#3730a3")}
                title="Emails this staff member a personal link (valid 24 hours) to view, update and submit their own weekly schedule."
                onClick={() => sendScheduleInvites({ dbName, staffIds: [staffId], label: staffName })}>
                ✉ Email schedule form
              </button>
            )}
            <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
          </div>
        </div>
        <StaffMonthDayList
          dbName={dbName} staffId={staffId} staffName={staffName}
          monthDays={monthDays} cellsForStaff={cellsForStaff || {}}
          fourWeekContractedH={fourWeekContractedH}
          onCellPatch={onCellPatch}
          onReload={onReload}
        />
        {showPattern && (
          <SchedulePatternDialog dbName={dbName} staffId={staffId} staffName={staffName}
            onClose={() => setShowPattern(false)}
            onSaved={async () => { setShowPattern(false); await onReload(); }} />
        )}
      </div>
    </div>
  );
}

/* -----------------------------------------------------------------------------
   "Configure scheduled hours" popup: the Mon–Sun pattern with start/end AND a
   per-day break length, plus one paid-breaks flag. "Save pattern" writes every
   weekday (occurrences 1–5) — the whole month — overwriting what was there;
   emptied days are cleared.
   ----------------------------------------------------------------------------- */
function SchedulePatternDialog({ dbName, staffId, staffName, onClose, onSaved }) {
  const WD_ORDER = [1, 2, 3, 4, 5, 6, 0];
  const WD_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const [rows, setRows] = useState(null);   // weekday -> {start,end,breakH}
  const [breaksPaid, setBreaksPaid] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await post("/api/headoffice/clock/times/get", { dbName, staffId });
        const byWd = {};
        for (const t of d.times || []) {
          if (byWd[t.weekday]) continue;
          byWd[t.weekday] = { start: t.start || "", end: t.end || "",
            breakH: t.breakMins ? String(Math.round((t.breakMins / 60) * 100) / 100) : "0" };
          if (t.breaksPaid) setBreaksPaid(true);
        }
        const r = {};
        for (const wd of WD_ORDER) r[wd] = byWd[wd] || { start: "", end: "", breakH: "0" };
        setRows(r);
      } catch (e) { setErr(e.message); setRows({}); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbName, staffId]);

  const edit = (wd, field, v) => setRows(r => ({ ...r, [wd]: { ...r[wd], [field]: v } }));

  const savePattern = async () => {
    if (!window.confirm(`Save this pattern to EVERY week of the month for ${staffName}? This overwrites the existing scheduled hours.`)) return;
    setBusy(true); setErr(null);
    try {
      for (const wd of WD_ORDER) {
        const r = rows[wd] || {};
        await post("/api/headoffice/clock/times/set", {
          dbName, staffId, weekday: wd, occurrences: [1, 2, 3, 4, 5],
          start: r.start || null, end: r.end || null,
          breakMins: Math.round(Number(r.breakH || 0) * 60), breaksPaid
        });
      }
      await post("/api/headoffice/clock/event/review", {
        dbName, staffId, date: new Date().toISOString().slice(0, 10),
        log: ["Weekly pattern saved to all weeks of the month via Configure scheduled hours"]
      }).catch(() => {});
      await onSaved();
    } catch (e) { setErr(e.message); setBusy(false); }
  };

  const inp = { ...S.inp };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9580 }}
         onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(560px, 94vw)", maxHeight: "88vh", overflowY: "auto", padding: 18 }}
           onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 }}>
          <div style={{ fontWeight: 800, fontSize: 15 }}>Configure scheduled hours — {staffName}</div>
          <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
        </div>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }}>
          Start/end and break length per weekday. Saving applies the pattern to every week of the month.
        </div>
        {err && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 8 }}>{err}</div>}
        {rows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading…</div>}
        {rows !== null && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "86px 1fr 12px 1fr 110px", gap: "6px 8px", alignItems: "center", fontSize: 13 }}>
              <div />
              <div style={{ ...S.lab, marginBottom: 0 }}>Start</div><div />
              <div style={{ ...S.lab, marginBottom: 0 }}>End</div>
              <div style={{ ...S.lab, marginBottom: 0 }}>Break (hrs)</div>
              {WD_ORDER.map(wd => (
                <React.Fragment key={wd}>
                  <div style={{ fontWeight: 700 }}>{WD_FULL[wd]}</div>
                  <input type="time" style={inp} value={rows[wd]?.start || ""} onChange={e => edit(wd, "start", e.target.value)}
                    title="Double-click to set 09:00–18:00"
                    onDoubleClick={() => { edit(wd, "start", "09:00"); edit(wd, "end", "18:00"); }} />
                  <span style={{ color: "#9ca3af", textAlign: "center" }}>–</span>
                  <input type="time" style={inp} value={rows[wd]?.end || ""} onChange={e => edit(wd, "end", e.target.value)} />
                  <input type="number" min="0" step="0.25" style={{ ...inp, width: 86 }} value={rows[wd]?.breakH ?? "0"}
                    onChange={e => edit(wd, "breakH", e.target.value)} />
                </React.Fragment>
              ))}
            </div>
            <div style={{ marginTop: 12, fontSize: 13.5, fontWeight: 700 }}
                 title="Four weeks of the pattern above: each scheduled day's hours minus that day's break when breaks are unpaid, times four. Updates live as you edit.">
              Four week contracted hours total: {(() => {
                let weeklyM = 0;
                for (const wd of WD_ORDER) {
                  const r = rows?.[wd];
                  if (!r || !r.start || !r.end) continue;
                  const [sh, sm] = r.start.split(":").map(Number), [eh, em] = r.end.split(":").map(Number);
                  let m = Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
                  if (!breaksPaid) m = Math.max(0, m - Math.round(Number(r.breakH || 0) * 60));
                  weeklyM += m;
                }
                return `${((weeklyM * 4) / 60).toFixed(2)}h`;
              })()}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10, flexWrap: "wrap", gap: 10 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                <input type="checkbox" checked={breaksPaid} onChange={e => setBreaksPaid(e.target.checked)} />
                Paid breaks?
              </label>
              <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none", fontWeight: 800, padding: "8px 18px" }}
                disabled={busy} onClick={savePattern}>
                {busy ? "Saving…" : "Save pattern"}
              </button>
            </div>
            <div style={{ fontSize: 11.5, color: "#9ca3af", marginTop: 8 }}>
              Days left empty are cleared (not scheduled). Overwrites the existing pattern for the whole month.
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* -----------------------------------------------------------------------------
   Right panel of the (month) staff dialog: one analysis card per day — the
   same figures the cell dialog shows — with AUTO-SAVING controls: reviewed
   tick (double-click the card also marks review complete), overtime approval,
   payroll hours and manager notes. Every save patches the month grid live.
   ----------------------------------------------------------------------------- */
function StaffMonthDayList({ dbName, staffId, staffName, monthDays, cellsForStaff, fourWeekContractedH, onCellPatch, onReload }) {
  const [patches, setPatches] = useState({});      // date -> saved field patches
  const [drafts, setDrafts] = useState({});        // date -> unsaved text drafts
  const [saveErr, setSaveErr] = useState(null);
  const [savedFlash, setSavedFlash] = useState(null);
  const [logFor, setLogFor] = useState(null);      // { date } — per-day change-log popup
  const [logRows, setLogRows] = useState(null);
  const openLog = async (date) => {
    setLogFor({ date }); setLogRows(null);
    try {
      const dd = await post("/api/headoffice/clock/review/history", { dbName, staffId, date });
      setLogRows(dd.log || []);
    } catch (e) { setLogRows([{ at: null, msg: `Could not load log: ${e.message}` }]); }
  };
  const cellOf = (date) => ({ ...(cellsForStaff[date] || {}), ...(patches[date] || {}) });

  const flash = (date) => {
    setSavedFlash(date);
    setTimeout(() => setSavedFlash(f => (f === date ? null : f)), 1600);
  };
  const friendly = (msg) => /Forbidden|not valid JSON|Unexpected token/i.test(String(msg))
    ? "the server refused the request (your session may have expired — refresh and log in again). The change was NOT saved and has been undone."
    : String(msg);
  const persist = async (date, patch, logMsgs) => {
    const before = {};
    const cur = cellOf(date);
    for (const k of Object.keys(patch)) before[k] = cur[k];
    setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), ...patch } }));
    onCellPatch && onCellPatch(date, patch);
    flash(date);
    try {
      await post("/api/headoffice/clock/event/review", { dbName, staffId, date,
        approved: patch.eventReviewed != null ? patch.eventReviewed : !!cellOf(date).eventReviewed,
        ...(patch.reviewNotes != null ? { notes: patch.reviewNotes } : {}),
        ...(patch.payrollHours != null ? { payrollHours: patch.payrollHours } : {}),
        ...(patch.payrollOtHours != null ? { payrollOtHours: patch.payrollOtHours } : {}),
        log: logMsgs || [] });
      setSaveErr(null);
    } catch (e) {
      setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), ...before } }));
      onCellPatch && onCellPatch(date, before);
      setSaveErr(`${dmy(date)}: save failed — ${friendly(e.message)}`);
    }
  };
  const approveOt = async (date, approved) => {
    const prev = !!cellOf(date).overtimeApproved;
    setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), overtimeApproved: approved } }));
    onCellPatch && onCellPatch(date, { overtimeApproved: approved });
    flash(date);
    try {
      await post("/api/headoffice/clock/overtime/approve", { dbName, staffId, date, approved });
      await post("/api/headoffice/clock/event/review", { dbName, staffId, date,
        approved: !!cellOf(date).eventReviewed,
        log: [`Overtime ${approved ? "approved" : "un-approved"} (staff dialogue)`] }).catch(() => {});
      setSaveErr(null);
    } catch (e) {
      setPatches(p => ({ ...p, [date]: { ...(p[date] || {}), overtimeApproved: prev } }));
      onCellPatch && onCellPatch(date, { overtimeApproved: prev });
      setSaveErr(`${dmy(date)}: overtime save failed — ${friendly(e.message)}`);
    }
  };
  /* Editing the SCHEDULED side saves that weekday's pattern (staff_times are a
     weekly pattern), then patches every same-weekday date in the month. */
  const persistPlanned = async (date, weekday, planned, logMsg) => {
    const affected = monthDays.filter(d => d.weekday === weekday).map(d => d.date);
    for (const dt of affected) {
      setPatches(p => ({ ...p, [dt]: { ...(p[dt] || {}), planned } }));
      onCellPatch && onCellPatch(dt, { planned });
    }
    flash(date);
    try {
      await post("/api/headoffice/clock/times/set", {
        dbName, staffId, weekday, occurrences: [1, 2, 3, 4, 5],
        start: planned.start || null, end: planned.end || null,
        breakMins: planned.breakMins || 0, breaksPaid: !!planned.breaksPaid
      });
      await post("/api/headoffice/clock/event/review", { dbName, staffId, date, log: [logMsg] }).catch(() => {});
      setSaveErr(null);
    } catch (e) { setSaveErr(`${dmy(date)}: schedule save failed — ${e.message}`); }
  };

  /* ---- layout: five sections separated by vertical rules, minimal height ---- */
  const COLS = "180px 235px 165px 195px minmax(430px, 1fr)";
  const secH = { fontSize: 10.5, fontWeight: 800, letterSpacing: 0.5, color: "#6b7280", textTransform: "uppercase", whiteSpace: "nowrap" };
  const tinyInp = { border: "1px solid #d1d5db", borderRadius: 4, fontSize: 12, padding: "1px 3px", fontFamily: "inherit" };
  const RULE = "1px solid rgba(15, 23, 42, 0.14)";
  const sec = { borderRight: RULE, paddingRight: 10, minWidth: 0, alignSelf: "stretch" };
  const ord = (n) => n + (n % 100 >= 11 && n % 100 <= 13 ? "th" : ["th", "st", "nd", "rd"][Math.min(n % 10, 4)] || "th");
  const hrs = (m) => (Math.round((m / 60) * 100) / 100).toFixed(2);

  /* one validation line: label + value, tinted when bad */
  const VLine = ({ label, bad, title, children }) => (
    <div title={title}
      style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 12, lineHeight: 1.45,
               padding: "0 4px", borderRadius: 3,
               background: bad ? "#fecaca" : "transparent",
               fontWeight: bad ? 800 : 500, color: bad ? "#991b1b" : "#374151" }}>
      <span style={{ color: bad ? "#991b1b" : "#6b7280", width: 42, flex: "0 0 42px" }}>{label}</span>
      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{children}</span>
    </div>
  );

  return (
    <div style={{ flex: 1, minWidth: 0, overflowY: "auto", padding: "8px 16px", background: "#fafafa" }}>
      {(() => null)()}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5, gap: 10, flexWrap: "wrap" }}>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          Changes save automatically {"\u00b7"} double-click a day to mark it reviewed {"\u00b7"} schedule edits apply to every matching weekday
        </div>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          <span style={{ background: "#dcfce7", padding: "1px 8px", borderRadius: 3 }}>approved</span>{" "}
          <span style={{ background: "#fde68a", padding: "1px 8px", borderRadius: 3 }}>needs attention</span>
        </div>
      </div>
      {saveErr && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 6 }}>{saveErr}</div>}

      <div style={{ display: "grid", gridTemplateColumns: COLS, gap: 10, padding: "2px 10px", marginBottom: 2 }}>
        <div style={secH}>Scheduled</div>
        <div style={secH}>What happened</div>
        <div style={secH}>Validation</div>
        <div style={secH}>Analysis</div>
        <div style={secH}>Review</div>
      </div>

      {monthDays.map(d => {
        const c = cellOf(d.date);
        const planned = c.planned || null;
        const sessions = c.sessions || [];
        const breaks = c.breaks || [];
        const calc = dayCalc(d.date, c);
        const issues = cellIssues(d.date, planned, sessions);
        const empty = !sessions.length && !planned;
        const approved = !!c.eventReviewed || calc.autoConf;
        const bg = empty ? "#fff" : approved ? "#dcfce7" : "#fde68a";
        const border = empty ? "#e5e7eb" : approved ? "#86efac" : "#f59e0b";
        const draft = drafts[d.date] || {};
        const setDraft = (field, v) => setDrafts(x => ({ ...x, [d.date]: { ...(x[d.date] || {}), [field]: v } }));
        const clearDraft = (field) => setDrafts(x => ({ ...x, [d.date]: { ...(x[d.date] || {}), [field]: undefined } }));

        const pStart = draft.pstart !== undefined ? draft.pstart : (planned?.start || "");
        const pEnd = draft.pend !== undefined ? draft.pend : (planned?.end || "");
        const pBreakH = draft.pbreak !== undefined ? draft.pbreak
          : (planned?.breakMins ? String(Math.round((planned.breakMins / 60) * 100) / 100) : "0");
        const pPaid = draft.ppaid !== undefined ? draft.ppaid : (planned?.breaksPaid === true);
        const commitPlanned = (over = {}) => {
          const np = {
            start: over.start !== undefined ? over.start : pStart,
            end: over.end !== undefined ? over.end : pEnd,
            breakMins: Math.round(Number(over.breakH !== undefined ? over.breakH : pBreakH || 0) * 60),
            breaksPaid: over.paid !== undefined ? over.paid : pPaid
          };
          const cur = planned || {};
          if ((cur.start || "") === np.start && (cur.end || "") === np.end &&
              (cur.breakMins || 0) === np.breakMins && (cur.breaksPaid === true) === np.breaksPaid) return;
          persistPlanned(d.date, d.weekday, np,
            `Scheduled hours for ${WEEKDAYS[d.weekday]}s set to ${np.start || "\u2014"}\u2013${np.end || "\u2014"}, break ${np.breakMins / 60}h ${np.breaksPaid ? "paid" : "unpaid"} (staff dialogue)`);
        };

        const notesVal = draft.notes !== undefined ? draft.notes : (c.reviewNotes || "");
        const saveNotes = () => {
          if (draft.notes === undefined || draft.notes === (c.reviewNotes || "")) { clearDraft("notes"); return; }
          const v = draft.notes; clearDraft("notes");
          persist(d.date, { reviewNotes: v }, ["Manager notes updated (staff dialogue)"]);
        };

        const firstIn = sessions.length ? sessions[0] : null;
        const lastOutSession = [...sessions].reverse().find(s => s.out) || null;
        const inDevice = firstIn ? firstIn.inDevice : null;
        const outDevice = lastOutSession ? lastOutSession.outDevice : null;
        const distIn = firstIn ? firstIn.distIn : null;
        const distOut = lastOutSession ? lastOutSession.distOut : null;
        const breakTakenM = breaks.reduce((t, b) => t + (b.mins || 0), 0);

        return (
          <div key={d.date}
            onDoubleClick={() => { if (!c.eventReviewed && !empty) persist(d.date, { eventReviewed: true }, ["Review marked complete (double-click in staff dialogue)"]); }}
            title={empty ? undefined : "Double-click to mark review complete"}
            style={{ display: "grid", gridTemplateColumns: COLS, gap: 10, alignItems: "start",
                     background: bg, border: `1px solid ${border}`, borderRadius: 6,
                     padding: "6px 26px 6px 10px", marginBottom: 4, opacity: empty ? 0.6 : 1,
                     fontSize: 12, lineHeight: 1.45, position: "relative" }}>
            {!empty && (
              <button onClick={e => { e.stopPropagation(); openLog(d.date); }}
                      title="View the change log for this day — every edit made here or in the cell dialogue is recorded."
                      style={{ position: "absolute", top: 3, right: 3, fontSize: 10, fontWeight: 700,
                               padding: "1px 7px", border: "1px solid #d1d5db", borderRadius: 4,
                               background: "#fff", color: "#374151", cursor: "pointer", fontFamily: "inherit" }}>
                Log
              </button>
            )}

            {/* 1 \u2014 DAY + SCHEDULED + contracted total */}
            <div style={sec}>
              <div style={{ fontWeight: 800, fontSize: 14, lineHeight: 1.2 }}>
                {WEEKDAYS[d.weekday]} {ord(d.day)}
                {savedFlash === d.date && <span style={{ fontSize: 11, color: "#15803d", marginLeft: 6 }}>{"\u2713"} saved</span>}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 3, whiteSpace: "nowrap", marginTop: 3 }}>
                <input type="time" style={tinyInp} value={pStart}
                  onChange={e => setDraft("pstart", e.target.value)}
                  onBlur={() => { commitPlanned(); clearDraft("pstart"); }} />
                <span style={{ color: "#9ca3af" }}>{"\u2013"}</span>
                <input type="time" style={tinyInp} value={pEnd}
                  onChange={e => setDraft("pend", e.target.value)}
                  onBlur={() => { commitPlanned(); clearDraft("pend"); }} />
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 3, whiteSpace: "nowrap", fontSize: 12 }}>
                <input type="number" min="0" step="0.25" style={{ ...tinyInp, width: 32 }} value={pBreakH}
                  onChange={e => setDraft("pbreak", e.target.value)}
                  onBlur={() => { commitPlanned(); clearDraft("pbreak"); }} />
                <span style={{ color: "#6b7280" }}>h break</span>
                <label style={{ display: "flex", alignItems: "center", gap: 3, cursor: "pointer" }}>
                  <input type="checkbox" checked={pPaid}
                    onChange={e => { setDraft("ppaid", e.target.checked); commitPlanned({ paid: e.target.checked }); }} />
                  Paid
                </label>
              </div>
              {calc.contractedM > 0 && (
                <div style={{ fontSize: 12, marginTop: 3, color: "#374151" }}>
                  Contracted <b>{hrs(calc.paidContractedM)}h</b>
                </div>
              )}
            </div>

            {/* 2 \u2014 WHAT HAPPENED: big read-only times, notes beside, totals below */}
            <div style={{ ...sec, fontSize: 12 }}>
              {!sessions.length && <span style={{ color: "#9ca3af", fontSize: 13 }}>No clockings recorded.</span>}
              {sessions.map((s, i) => (
                <div key={i} style={{ display: "flex", alignItems: "baseline", gap: 10, whiteSpace: "nowrap", minWidth: 0 }}>
                  <span style={{ fontSize: 14.5, fontWeight: 800, letterSpacing: 0.2 }}>
                    {hm(s.in) || "\u2014"} {"\u2013"} {s.out ? hm(s.out) : "still in"}
                  </span>
                  {(s.inNotes || s.outNotes) && (
                    <span style={{ color: "#92400e", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis" }}
                          title={[s.inNotes, s.outNotes].filter(Boolean).join(" \u00b7 ")}>
                      {"\u270e"} {[s.inNotes, s.outNotes].filter(Boolean).join(" \u00b7 ")}
                    </span>
                  )}
                </div>
              ))}
              {breaks.map((b, i) => (
                <div key={"b" + i} style={{ color: "#7c3aed" }}>
                  break {hm(b.start) || "?"}{"\u2013"}{b.end ? hm(b.end) : "\u2026"} ({b.mins || 0}m)
                </div>
              ))}
              {sessions.length > 0 && (
                <div style={{ marginTop: 1, color: "#374151" }}>
                  <div>Total hrs on site <b>{hrs(calc.actualM)}h</b>{calc.stillIn ? " (open)" : ""}</div>
                  <div>Total breaks <b>{hrs(breakTakenM)}h</b></div>
                </div>
              )}
            </div>

            {/* 3 \u2014 VALIDATION: vertical column, tinted lines when bad */}
            <div style={sec}>
              <VLine label="in" bad={distIn != null && distIn > DIST_LIMIT_M}
                     title={`How far from the pharmacy’s registered location the CLOCK-IN was made${distIn != null ? ` — ${distText(distIn)} away` : " — not recorded"}. Flagged red when over ${DIST_LIMIT_M} m.`}>
                {distIn == null ? "\u2014" : `${distIn > DIST_LIMIT_M ? "\u2717" : "\u2713"} ${distText(distIn)}`}
              </VLine>
              <VLine label="out" bad={distOut != null && distOut > DIST_LIMIT_M}
                     title={`How far from the pharmacy’s registered location the CLOCK-OUT was made${distOut != null ? ` — ${distText(distOut)} away` : " — not recorded"}. Flagged red when over ${DIST_LIMIT_M} m.`}>
                {distOut == null ? "\u2014" : `${distOut > DIST_LIMIT_M ? "\u2717" : "\u2713"} ${distText(distOut)}`}
              </VLine>
              <VLine label="id in" bad={!!c.deviceChangedIn}
                     title={`The device the CLOCK-IN was made on${inDevice ? `: ${inDevice}` : " — not recorded"}. Flagged red when it differs from the device used on the previous day${c.deviceChangedIn && c.prevInDevice ? ` (was ${c.prevInDevice})` : ""}.`}>
                {inDevice ? <span style={{ fontFamily: "monospace" }}>{String(inDevice).slice(0, 8)}{c.deviceChangedIn ? " \u26a0" : ""}</span> : "\u2014"}
              </VLine>
              <VLine label="id out" bad={!!c.deviceChangedOut}
                     title={`The device the CLOCK-OUT was made on${outDevice ? `: ${outDevice}` : " — not recorded"}. Flagged red when it differs from the device used on the previous day${c.deviceChangedOut && c.prevOutDevice ? ` (was ${c.prevOutDevice})` : ""}.`}>
                {outDevice ? <span style={{ fontFamily: "monospace" }}>{String(outDevice).slice(0, 8)}{c.deviceChangedOut ? " \u26a0" : ""}</span> : "\u2014"}
              </VLine>
            </div>

            {/* 4 \u2014 ANALYSIS */}
            <div style={{ ...sec }}>
              {sessions.length > 0 && (
                <div title="Hours on site (net of unpaid breaks) counted toward the day's contracted hours, capped at the contracted figure. Anything above spills into potential overtime below.">
                  Contracted hrs covered: <b>{hrs(Math.min(calc.netActualM, calc.paidContractedM > 0 ? calc.paidContractedM : calc.netActualM))}h</b>
                  {calc.paidContractedM > 0 ? <span style={{ color: "#6b7280" }}> of {hrs(calc.paidContractedM)}h</span> : null}
                </div>
              )}
              {sessions.length > 0 && (
                <div style={{ color: calc.potOtM > 12 ? "#1d4ed8" : "#6b7280", fontWeight: calc.potOtM > 12 ? 700 : 400 }}
                     title="Net hours on site above the day's contracted hours: the surplus once contracted hours are covered.">
                  Potential overtime: <b>{hrs(calc.potOtM)}h</b>
                </div>
              )}
              {issues.length > 0 && <div style={{ color: "#b45309" }}>{"\u26a0"} {issues.join("; ")}</div>}
              <label style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 2, whiteSpace: "nowrap",
                              color: calc.autoConf ? "#15803d" : "#9ca3af" }}
                     title="Set automatically when the day is clean and complete: on time, in range, fully clocked out, no notes, no significant overtime. Read-only.">
                <input type="checkbox" checked={calc.autoConf} disabled readOnly />
                Auto review
              </label>
            </div>

            {/* 5 \u2014 REVIEW */}
            <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ flex: "0 0 auto" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                   title="Standard hours to go on the payroll sheet for this day. Defaults to the on-site hours (net of unpaid breaks) that satisfy the contracted figure; edit to override.">
                <span style={{ color: "#374151", width: 148 }}>Cont hrs on payroll</span>
                <input type="number" min="0" step="0.25" disabled={empty}
                  value={draft.pstd !== undefined ? draft.pstd
                    : (c.payrollHours != null ? String(c.payrollHours)
                      : hrs(Math.min(calc.netActualM, calc.paidContractedM > 0 ? calc.paidContractedM : calc.netActualM)))}
                  onChange={e => setDraft("pstd", e.target.value)}
                  onBlur={() => {
                    if (draft.pstd === undefined) return;
                    const v = Math.max(0, Math.round(Number(draft.pstd || 0) * 100) / 100);
                    clearDraft("pstd");
                    if (c.payrollHours != null && v === c.payrollHours) return;
                    persist(d.date, { payrollHours: v }, [`Payroll standard hours set to ${v.toFixed(2)} (staff dialogue)`]);
                  }}
                  style={{ ...tinyInp, width: 56 }} /> h
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap", marginTop: 3 }}
                   title="Overtime hours to go on the payroll sheet for this day. Defaults to the surplus above contracted hours; edit to override. Tick Approved to accept the overtime.">
                <span style={{ color: "#374151", width: 148 }}>O/time hrs on payroll</span>
                <input type="number" min="0" step="0.25" disabled={empty}
                  value={draft.pot !== undefined ? draft.pot
                    : (c.payrollOtHours != null ? String(c.payrollOtHours) : hrs(calc.potOtM))}
                  onChange={e => setDraft("pot", e.target.value)}
                  onBlur={() => {
                    if (draft.pot === undefined) return;
                    const v = Math.max(0, Math.round(Number(draft.pot || 0) * 100) / 100);
                    clearDraft("pot");
                    if (c.payrollOtHours != null && v === c.payrollOtHours) return;
                    persist(d.date, { payrollOtHours: v }, [`Payroll overtime hours set to ${v.toFixed(2)} (staff dialogue)`]);
                  }}
                  style={{ ...tinyInp, width: 56 }} /> h
                {(() => {
                  const otBoxVal = Number(draft.pot !== undefined ? draft.pot
                    : (c.payrollOtHours != null ? c.payrollOtHours : hrs(calc.potOtM))) || 0;
                  const otEnabled = calc.potOtM > 12 || otBoxVal > 0;
                  return (
                    <label style={{ display: "flex", alignItems: "center", gap: 4, marginLeft: 8,
                                    cursor: otEnabled ? "pointer" : "default",
                                    color: otEnabled ? "#1d4ed8" : "#9ca3af", fontWeight: otEnabled ? 700 : 400 }}>
                      <input type="checkbox" checked={!!c.overtimeApproved} disabled={!otEnabled}
                        onChange={e => approveOt(d.date, e.target.checked)} />
                      Approved
                    </label>
                  );
                })()}
              </div>
              </div>
              <textarea value={notesVal} rows={3} placeholder={"Manager notes\u2026"} disabled={empty}
                onChange={e => setDraft("notes", e.target.value)} onBlur={saveNotes}
                style={{ ...tinyInp, flex: "0 0 132px", width: 132, height: 54, resize: "none",
                         boxSizing: "border-box", padding: "3px 6px", background: "#fff", fontFamily: "inherit" }} />
              <label style={{ display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap", flex: "0 0 auto",
                              cursor: empty ? "default" : "pointer",
                              fontWeight: 700, color: c.eventReviewed ? "#15803d" : "#374151" }}
                     onDoubleClick={e => e.stopPropagation()}>
                <input type="checkbox" checked={!!c.eventReviewed} disabled={empty}
                  onChange={e => persist(d.date, { eventReviewed: e.target.checked }, [`Review ${e.target.checked ? "marked complete" : "re-opened"} (staff dialogue)`])} />
                Review complete
              </label>
            </div>
          </div>
        );
      })}
      {logFor && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9590 }}
             onClick={() => setLogFor(null)}>
          <div style={{ background: "#fff", borderRadius: 8, width: "min(560px, 92vw)", maxHeight: "80vh", overflowY: "auto", padding: 16 }}
               onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontWeight: 800 }}>Change log {"\u2014"} {staffName}, {dmy(logFor.date)}</div>
              <button style={S.btn("#6b7280")} onClick={() => setLogFor(null)}>Close</button>
            </div>
            {logRows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading{"\u2026"}</div>}
            {logRows !== null && !logRows.length && <div style={{ fontSize: 13, color: "#6b7280" }}>No changes recorded yet for this day.</div>}
            {(logRows || []).map((l, i) => (
              <div key={i} style={{ borderBottom: "1px solid #f1f5f9", padding: "6px 0", fontSize: 12.5 }}>
                <div style={{ color: "#6b7280", fontSize: 11.5 }}>
                  {l.at ? new Date(l.at).toLocaleString("en-GB") : ""}{l.by ? ` \u2014 ${l.by}` : ""}
                </div>
                <div>{l.msg}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function CellDialog({ dbName, entry, onLocalPatch, onReload, onClose, roleName }) {
  const [dlgErr, setDlgErr] = useState(null);
  const [start, setStart] = useState(entry.planned?.start || "");
  const [end, setEnd] = useState(entry.planned?.end || "");
  const [breakH, setBreakH] = useState(entry.planned?.breakMins ? String(Math.round((entry.planned.breakMins / 60) * 100) / 100) : "0");
  const [breaksPaid, setBreaksPaid] = useState(entry.planned?.breaksPaid === true);
  const [timesDirty, setTimesDirty] = useState(false);
  const [timesMsg, setTimesMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [noteDraft, setNoteDraft] = useState(entry.reviewNotes || "");
  const [logOpen, setLogOpen] = useState(false);
  const [logRows, setLogRows] = useState(null);

  // ---------- derived figures ----------
  const sessions = entry.sessions || [];
  const breaks = entry.breaks || [];
  const contractedM = (start && end) ? (() => {
    const [sh, sm] = start.split(":").map(Number), [eh, em] = end.split(":").map(Number);
    return Math.max(0, (eh * 60 + (em || 0)) - (sh * 60 + (sm || 0)));
  })() : 0;
  let actualM = 0;
  for (const s of sessions) if (s.in && s.out) actualM += Math.max(0, (new Date(s.out) - new Date(s.in)) / 60000);
  const stillIn = sessions.some(s => s.in && !s.out);
  const breakTakenM = breaks.reduce((t, b) => t + (b.mins || 0), 0);
  const hFmt = (mins) => `${Math.floor(mins / 60)}h ${Math.round(mins % 60)}m`;
  const hDec = (mins) => (Math.round((mins / 60) * 100) / 100).toFixed(2);
  const covered = actualM + 0.5 >= contractedM;
  // Paid contracted hours: hours on site minus the break entitlement — but
  // the break is only deducted when it is UNPAID.
  const breakEntM = Math.round(Number(breakH || 0) * 60);
  const paidContractedM = contractedM > 0 ? Math.max(0, contractedM - (breaksPaid ? 0 : breakEntM)) : 0;
  // Payroll default: total hours on site LESS total break time taken when
  // breaks are unpaid (paid breaks deduct nothing), capped at the day's
  // paid contracted hours; any surplus is the potential overtime (exposed
  // above 0.2h).
  const netActualM = Math.max(0, actualM - (breaksPaid ? 0 : breakTakenM));
  const payrollAutoM = Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM);
  const potOtM = Math.max(0, netActualM - (paidContractedM > 0 ? paidContractedM : netActualM));
  const showOt = potOtM > 12; // 0.2h
  const issues = cellIssues(entry.date, (start || end) ? { start, end } : null, sessions);
  const deviceChanged = !!(entry.deviceChangedIn || entry.deviceChangedOut);
  const isAuto = autoConfirmed(entry.date, (start || end) ? { start, end } : null, sessions, potOtM, deviceChanged);
  // Devices used for this day's clockings (unique, in order of use).
  const inDevices = [...new Set(sessions.map(s => s.inDevice).filter(Boolean))];
  const outDevices = [...new Set(sessions.map(s => s.outDevice).filter(Boolean))];
  const payrollDefault = hDec(payrollAutoM);
  const [payroll, setPayroll] = useState(entry.payrollHours != null ? String(entry.payrollHours) : payrollDefault);
  const [payrollTouched, setPayrollTouched] = useState(entry.payrollHours != null);
  useEffect(() => { if (!payrollTouched) setPayroll(payrollDefault); }, [payrollDefault, payrollTouched]);
  const otDefault = hDec(potOtM);
  const [otPayroll, setOtPayroll] = useState(entry.payrollOtHours != null ? String(entry.payrollOtHours) : otDefault);
  const [otTouched, setOtTouched] = useState(entry.payrollOtHours != null);
  useEffect(() => { if (!otTouched) setOtPayroll(otDefault); }, [otDefault, otTouched]);
  const saveOtPayroll = () => {
    const v = Math.max(0, Math.round(Number(otPayroll || 0) * 100) / 100);
    setOtPayroll(v.toFixed(2));
    if (entry.payrollOtHours != null ? v === entry.payrollOtHours : v.toFixed(2) === otDefault) { setOtTouched(entry.payrollOtHours != null); return; }
    onLocalPatch({ payrollOtHours: v });
    review({ payrollOtHours: v }, [`Payroll overtime hours set to ${v.toFixed(2)} (potential ${otDefault})`]);
  };

  // ---------- persistence ----------
  const review = async (patch, logMsgs) => {
    try {
      await post("/api/headoffice/clock/event/review",
        { dbName, staffId: entry.staffId, date: entry.date, ...patch, log: logMsgs || [] });
    } catch (e) { setDlgErr(`Save failed: ${e.message}`); await onReload(); }
  };
  const setReviewComplete = (approved) => {
    onLocalPatch({ eventReviewed: approved, reviewNotes: noteDraft });
    review({ approved, notes: noteDraft }, [`Review ${approved ? "marked complete" : "re-opened"}`]);
  };
  const saveNotes = () => {
    if (noteDraft === (entry.reviewNotes || "")) return;
    onLocalPatch({ reviewNotes: noteDraft });
    review({ notes: noteDraft, approved: !!entry.eventReviewed }, ["Manager notes updated"]);
  };
  const savePayroll = () => {
    const v = Math.max(0, Math.round(Number(payroll || 0) * 100) / 100);
    setPayroll(v.toFixed(2));
    if (entry.payrollHours != null ? v === entry.payrollHours : v.toFixed(2) === payrollDefault) { setPayrollTouched(entry.payrollHours != null); return; }
    onLocalPatch({ payrollHours: v });
    review({ payrollHours: v }, [`Hours to go on payroll sheet changed to ${v.toFixed(2)} (contracted ${payrollDefault})`]);
  };
  const acceptOvertime = (approved) => {
    onLocalPatch({ overtimeApproved: approved });
    (async () => {
      try {
        await post("/api/headoffice/clock/overtime/approve", { dbName, staffId: entry.staffId, date: entry.date, approved });
        await review({}, [`Overtime of ${hDec(potOtM)}h ${approved ? "accepted" : "un-accepted"}`]);
      } catch (e) { setDlgErr(`Overtime save failed: ${e.message}`); await onReload(); }
    })();
  };
  const saveWeekday = async () => {
    setBusy(true); setDlgErr(null);
    try {
      await post("/api/headoffice/clock/times/set", {
        dbName, staffId: entry.staffId, weekday: entry.weekday,
        occurrences: [1, 2, 3, 4, 5], start: start || null, end: end || null,
        breakMins: Math.round(Number(breakH || 0) * 60), breaksPaid
      });
      await review({}, [`Contracted times saved to ${entry.staffName} for every ${WEEKDAYS[entry.weekday]}: ${start || "—"}–${end || "—"}, break ${Number(breakH || 0)}h ${breaksPaid ? "paid" : "unpaid"} (manual)`]);
      setTimesMsg(`✔ Saved to ${entry.staffName} for every ${WEEKDAYS[entry.weekday]}`); setTimesDirty(false);
      await onReload();
    } catch (e) { setDlgErr(e.message); } finally { setBusy(false); }
  };
  const copyTimes = async (scope) => {
    const label = scope === "staff"
      ? `Copy ${start || "—"}–${end || "—"} to EVERY day of the week for ${entry.staffName}?`
      : `Copy ${start || "—"}–${end || "—"} to EVERY day for ALL staff members at this pharmacy?`;
    if (!window.confirm(label)) return;
    setBusy(true); setDlgErr(null);
    try {
      const r = await post("/api/headoffice/clock/times/copy",
        { dbName, staffId: entry.staffId, start: start || null, end: end || null,
          breakMins: Math.round(Number(breakH || 0) * 60), breaksPaid, scope });
      await review({}, [scope === "staff"
        ? `Contracted times ${start || "—"}–${end || "—"} copied to all days for ${entry.staffName}`
        : `Contracted times ${start || "—"}–${end || "—"} copied to all days for all staff (${r.staffCount} members)`]);
      setTimesMsg(scope === "staff" ? "✔ Copied to all days for this staff member"
        : `✔ Copied to all days for all ${r.staffCount} staff members`);
      setTimesDirty(false);
      await onReload();
    } catch (e) { setDlgErr(e.message); } finally { setBusy(false); }
  };
  const openLog = async () => {
    setLogOpen(true); setLogRows(null);
    try {
      // '/history' not '/log' — IIS security filtering 403s '/log' URLs
      // before they reach the backend (plain-text Forbidden).
      const d = await post("/api/headoffice/clock/review/history", { dbName, staffId: entry.staffId, date: entry.date });
      setLogRows(d.log || []);
    } catch (e) { setLogRows([{ at: null, msg: `Could not load log: ${e.message}` }]); }
  };

  // ---------- panels ----------
  const P = { border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px 14px", background: "#fafafa", minWidth: 0 };
  const H = { fontSize: 11, fontWeight: 800, letterSpacing: 0.5, color: "#6b7280", textTransform: "uppercase", marginBottom: 8 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9500 }}>
      <div style={{ background: "#fff", borderRadius: 8, width: "min(1320px, 97vw)", maxHeight: "92vh", overflowY: "auto", padding: 18 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10 }}>
          <div style={{ fontWeight: 800, fontSize: 15 }}>{entry.staffName} — {dmy(entry.date)} ({WEEKDAYS[entry.weekday]})</div>
          <button style={S.btn("#6b7280")} onClick={onClose}>Close</button>
        </div>
        {dlgErr && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 8 }}>{dlgErr}</div>}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 12 }}>

          {/* ---------------- 1. STAFF & CONTRACTED ---------------- */}
          <div style={P}>
            <div style={H}>Staff & contracted hours</div>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{entry.staffName}</div>
            <div style={{ fontSize: 12.5, color: "#6b7280", marginBottom: 12 }}>{roleName || entry.roleName || "—"}</div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
              <div><div style={S.lab}>Contracted start</div>
                <input type="time" style={S.inp} value={start}
                  onChange={e => { setStart(e.target.value); setTimesDirty(true); setTimesMsg(null); }} /></div>
              <div><div style={S.lab}>Contracted finish</div>
                <input type="time" style={S.inp} value={end}
                  onChange={e => { setEnd(e.target.value); setTimesDirty(true); setTimesMsg(null); }} /></div>
            </div>
            <div style={{ marginTop: 12, fontSize: 13 }}>
              Hours to be on site: <b>{contractedM > 0 ? `${hFmt(contractedM)} (${hDec(contractedM)}h)` : "—"}</b>
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginTop: 10 }}>
              <div><div style={S.lab}>Break entitlement (hrs)</div>
                <input type="number" min="0" step="0.25" value={breakH}
                  onChange={e => { setBreakH(e.target.value); setTimesDirty(true); setTimesMsg(null); }}
                  style={{ ...S.inp, width: 78 }} /></div>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, paddingBottom: 7, cursor: "pointer" }}>
                <input type="checkbox" checked={breaksPaid}
                  onChange={e => { setBreaksPaid(e.target.checked); setTimesDirty(true); setTimesMsg(null); }} />
                Paid?
              </label>
            </div>
            <div style={{ marginTop: 10, fontSize: 13 }}
                 title="Four weeks of this member's weekly pattern: each scheduled day's hours minus the break entitlement when unpaid, times four.">
              Four week contracted hours total: <b>{entry.fourWeekContractedH != null ? `${entry.fourWeekContractedH.toFixed(2)}h` : "—"}</b>
            </div>
            <div style={{ marginTop: 10, fontSize: 13 }}>
              Paid contracted hrs: <b>{contractedM > 0 ? `${hFmt(paidContractedM)} (${hDec(paidContractedM)}h)` : "—"}</b>
              {contractedM > 0 && breakEntM > 0 && (
                <span style={{ color: "#6b7280", fontSize: 12 }}> {breaksPaid ? "(breaks paid — nothing deducted)" : "(hours on site minus unpaid break)"}</span>
              )}
            </div>
            {timesDirty && (
              <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 12 }}>
                <button style={{ ...S.btn("#fff"), background: "#0f766e", color: "#fff", border: "none" }} disabled={busy} onClick={saveWeekday}>
                  Save to this staff member for every {WEEKDAYS[entry.weekday]}
                </button>
                <button style={S.btn("#0f766e")} disabled={busy} onClick={() => copyTimes("staff")}>
                  Copy to all days for this staff member
                </button>
                <button style={S.btn("#0f766e")} disabled={busy} onClick={() => copyTimes("pharmacy")}>
                  Copy to all days for all staff members
                </button>
              </div>
            )}
            {timesMsg && <div style={{ marginTop: 10, fontSize: 13, fontWeight: 700, color: "#15803d" }}>{timesMsg}</div>}

          </div>

          {/* ---------------- 2. SESSIONS ---------------- */}
          <div style={P}>
            <div style={H}>Clock in / clock out sessions</div>
            {!sessions.length && <div style={{ fontSize: 13, color: "#6b7280" }}>No clockings recorded for this day.</div>}
            {sessions.map((s, i) => (
              <div key={i} style={{ border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff", padding: "8px 10px", marginBottom: 8, fontSize: 13 }}>
                {sessions.length > 1 && <div style={{ fontWeight: 800, fontSize: 11.5, color: "#6b7280", marginBottom: 3 }}>SESSION #{i + 1}</div>}
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <span><b>In</b> {hm(s.in) || "—"}</span>
                  <span style={{ color: s.distIn != null && s.distIn > DIST_LIMIT_M ? "#dc2626" : "#374151" }}>
                    {s.distIn != null ? `${distText(s.distIn)}${s.distIn > DIST_LIMIT_M ? " ⚠" : ""} away` : "distance not recorded"}
                  </span>
                </div>
                <div style={{ fontSize: 12, margin: "2px 0 6px" }}>
                  <span style={{ color: "#6b7280" }}>Notes (clock in): </span>
                  <span style={{ color: s.inNotes ? "#92400e" : "#9ca3af" }}>{s.inNotes || "—"}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <span><b>Out</b> {s.out ? hm(s.out) : "still clocked in"}</span>
                  <span style={{ color: s.distOut != null && s.distOut > DIST_LIMIT_M ? "#dc2626" : "#374151" }}>
                    {s.out ? (s.distOut != null ? `${distText(s.distOut)}${s.distOut > DIST_LIMIT_M ? " ⚠" : ""} away` : "distance not recorded") : "—"}
                  </span>
                </div>
                <div style={{ fontSize: 12, marginTop: 2 }}>
                  <span style={{ color: "#6b7280" }}>Notes (clock out): </span>
                  <span style={{ color: s.outNotes ? "#92400e" : "#9ca3af" }}>{s.outNotes || "—"}</span>
                </div>
              </div>
            ))}
            <div style={{ ...H, marginTop: 10 }}>Breaks</div>
            {!breaks.length && <div style={{ fontSize: 12.5, color: "#9ca3af", marginBottom: 8 }}>No breaks recorded.</div>}
            {breaks.map((b, i) => (
              <div key={i} style={{ fontSize: 12.5, color: "#374151", marginBottom: 3 }}>
                Break from <b>{hm(b.start) || "?"}</b> to <b>{b.end ? hm(b.end) : "…"}</b> ({b.mins || 0}m)
              </div>
            ))}
            <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 8, marginTop: 8, fontSize: 13 }}>
              <div>Total hours on site: <b>{hFmt(actualM)} ({hDec(actualM)}h)</b>{stillIn ? " — session still open" : ""}</div>
              <div style={{ marginTop: 3 }}>Total break time taken: <b>{hFmt(breakTakenM)} ({hDec(breakTakenM)}h)</b></div>
            </div>
          </div>

          {/* ---------------- 3. SUMMARY ---------------- */}
          <div style={P}>
            <div style={H}>Summary</div>
            <div style={{ fontSize: 13, marginBottom: 4 }}
                 title="Hours on site (net of unpaid breaks) counted toward the day's contracted hours, capped at the contracted figure.">
              Contracted hrs covered: <b style={{ color: covered ? "#15803d" : "#dc2626" }}>{hDec(Math.min(netActualM, paidContractedM > 0 ? paidContractedM : netActualM))}h</b>
              {paidContractedM > 0 && <span style={{ color: "#6b7280" }}> of {hDec(paidContractedM)}h</span>}
              <span style={{ marginLeft: 6 }}>{covered ? "✓" : "✗"}</span>
            </div>
            <div style={{ fontSize: 13, marginBottom: 8, color: potOtM > 12 ? "#1d4ed8" : "#6b7280", fontWeight: potOtM > 12 ? 700 : 400 }}
                 title="Net hours on site above the day's contracted hours: the surplus once contracted hours are covered.">
              Potential overtime: {hDec(potOtM)}h
            </div>
            <div style={{ fontSize: 13, marginBottom: 6, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                 title="Standard hours to go on the payroll sheet for this day. Defaults to the on-site hours that satisfy the contracted figure; edit to override.">
              <span style={{ width: 148 }}>Cont hrs on payroll</span>
              <input type="number" min="0" step="0.25" value={payroll}
                onChange={e => { setPayroll(e.target.value); setPayrollTouched(true); }}
                onBlur={savePayroll}
                style={{ ...S.inp, width: 74, padding: "3px 6px" }} />
              <span style={{ color: "#6b7280" }}>h</span>
            </div>
            <div style={{ fontSize: 13, marginBottom: 10, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                 title="Overtime hours to go on the payroll sheet for this day. Defaults to the surplus above contracted hours; edit to override. Tick Approved to accept the overtime.">
              <span style={{ width: 148 }}>O/time hrs on payroll</span>
              <input type="number" min="0" step="0.25" value={otPayroll}
                onChange={e => { setOtPayroll(e.target.value); setOtTouched(true); }}
                onBlur={saveOtPayroll}
                style={{ ...S.inp, width: 74, padding: "3px 6px" }} />
              <span style={{ color: "#6b7280" }}>h</span>
              {(() => {
                const otEnabled = potOtM > 12 || (Number(otPayroll) || 0) > 0;
                return (
                  <label style={{ display: "flex", alignItems: "center", gap: 5, marginLeft: 6,
                                  cursor: otEnabled ? "pointer" : "default",
                                  color: otEnabled ? "#1d4ed8" : "#9ca3af", fontWeight: otEnabled ? 700 : 400 }}>
                    <input type="checkbox" checked={!!entry.overtimeApproved} disabled={!otEnabled}
                      onChange={e => acceptOvertime(e.target.checked)} />
                    Approved
                  </label>
                );
              })()}
            </div>
            <div style={S.lab}>Manager notes</div>
            <textarea value={noteDraft}
              onChange={e => setNoteDraft(e.target.value)}
              onBlur={saveNotes}
              placeholder="Comments about this day's clocking event."
              rows={3}
              style={{ width: "100%", boxSizing: "border-box", fontSize: 12.5, padding: "6px 8px", border: "1px solid #d1d5db", borderRadius: 4, fontFamily: "inherit", resize: "vertical", marginBottom: 10 }} />
            <button style={S.btn("#374151")} onClick={openLog}>Log</button>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13.5, fontWeight: 700, color: "#15803d",
                            background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 6, padding: "8px 10px", cursor: "pointer", marginTop: 10 }}>
              <input type="checkbox" checked={!!entry.eventReviewed} onChange={e => setReviewComplete(e.target.checked)} />
              Review complete
            </label>
            <div style={{ fontSize: 12.5, color: "#6b7280", marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 5, whiteSpace: "nowrap",
                              color: isAuto ? "#15803d" : "#9ca3af" }}
                     title="Set automatically when the day is clean and complete: on time, in range, fully clocked out, no notes, no significant overtime. Read-only.">
                <input type="checkbox" checked={isAuto} disabled readOnly />
                Auto review
              </label>
              {deviceChanged && <div style={{ color: "#dc2626", marginTop: 4 }}>auto review blocked: clocking device changed</div>}
              {issues.length > 0 && <div style={{ color: "#dc2626", marginTop: 4 }}>⚠ {issues.join("; ")}</div>}
            </div>
          </div>
        </div>

        {/* Device ids — bottom corner. A red background marks the value
            that CHANGED versus the last recorded clocking. */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
          <div style={{ fontSize: 11, color: "#6b7280", textAlign: "right" }}>
            <span>Clock-in device: </span>
            <span style={entry.deviceChangedIn
              ? { background: "#dc2626", color: "#fff", borderRadius: 3, padding: "1px 5px", fontWeight: 700 }
              : { fontWeight: 600 }}>
              {inDevices.length ? inDevices.join(", ") : "not recorded"}
            </span>
            {entry.deviceChangedIn && entry.prevInDevice && (
              <span> (was {entry.prevInDevice})</span>
            )}
            <span style={{ margin: "0 8px", color: "#d1d5db" }}>|</span>
            <span>Clock-out device: </span>
            <span style={entry.deviceChangedOut
              ? { background: "#dc2626", color: "#fff", borderRadius: 3, padding: "1px 5px", fontWeight: 700 }
              : { fontWeight: 600 }}>
              {outDevices.length ? outDevices.join(", ") : "not recorded"}
            </span>
            {entry.deviceChangedOut && entry.prevOutDevice && (
              <span> (was {entry.prevOutDevice})</span>
            )}
          </div>
        </div>

        {/* ---------------- LOG POPUP ---------------- */}
        {logOpen && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9600 }}
               onClick={() => setLogOpen(false)}>
            <div style={{ background: "#fff", borderRadius: 8, width: "min(560px, 92vw)", maxHeight: "80vh", overflowY: "auto", padding: 16 }}
                 onClick={e => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <div style={{ fontWeight: 800 }}>Change log — {entry.staffName}, {dmy(entry.date)}</div>
                <button style={S.btn("#6b7280")} onClick={() => setLogOpen(false)}>Close</button>
              </div>
              {logRows === null && <div style={{ fontSize: 13, color: "#6b7280" }}>Loading…</div>}
              {logRows !== null && !logRows.length && <div style={{ fontSize: 13, color: "#6b7280" }}>No changes recorded yet for this day.</div>}
              {(logRows || []).map((l, i) => (
                <div key={i} style={{ borderBottom: "1px solid #f1f5f9", padding: "6px 0", fontSize: 12.5 }}>
                  <div style={{ color: "#6b7280", fontSize: 11.5 }}>
                    {l.at ? new Date(l.at).toLocaleString("en-GB") : ""}{l.by ? ` — ${l.by}` : ""}
                  </div>
                  <div>{l.msg}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ============================================================================
   TAB 1 — Day view: branches x staff (grouped by role)
   ============================================================================ */
function DayTab() {
  const [date, setDate] = useState(todayStr());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [activeRoles, setActiveRoles] = useState(new Set());
  const [dlg, setDlg] = useState(null); // { dbName, entry } — shared CellDialog
  const [schedDlg, setSchedDlg] = useState(null); // { dbName, staffId, staffName, roleName } — weekly schedule editor

  const load = useCallback(async (d) => {
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/day", { date: d });
      setData(res);
      setActiveRoles(prev => prev.size ? prev : new Set(res.roles));
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(date); }, [date, load]);

  const roles = data?.roles || [];
  const shownRoles = roles.filter(r => activeRoles.has(r));

  const doExport = () => {
    if (!data) return;
    // One TAB PER PHARMACY, tab label = abbreviated pharmacy name. Each tab
    // carries its own header block; the Pharmacy column is redundant on a
    // per-pharmacy tab so the grid is Staff / Role / Clocked / Planned / Notes.
    const dateLine = `Date: ${new Date(`${date}T00:00:00`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}`;
    const sheets = [];
    for (const ph of data.pharmacies) {
      const rows = [];
      for (const s of ph.staff) {
        if (!activeRoles.has(s.roleName)) continue;
        const c = dayCalc(date, s);
        rows.push({
          Staff: s.staffName, Role: s.roleName,
          "Four week contracted (h)": s.fourWeekContractedH != null ? s.fourWeekContractedH : "",
          "Contracted": s.planned ? `${s.planned.start || ""}–${s.planned.end || ""}` : "",
          "Hours to be on site (h)": c.contractedM > 0 ? h1(c.contractedM) : "",
          "Break entitlement (h)": c.breakEntM > 0 ? h1(c.breakEntM) : "",
          "Breaks paid": s.planned ? (c.breaksPaid ? "Yes" : "No") : "",
          "Paid contracted (h)": c.paidContractedM > 0 ? h1(c.paidContractedM) : "",
          "Clocked": sessionsText(s.sessions),
          "Distance in (m)": s.sessions.map(x => x.distIn != null ? x.distIn : "").filter(x => x !== "").join(", "),
          "Distance out (m)": s.sessions.map(x => x.distOut != null ? x.distOut : "").filter(x => x !== "").join(", "),
          ">50m flag": anyFar(s.sessions) ? "YES" : "",
          "Hours on site (h)": s.sessions.length ? h1(c.actualM) : "",
          "Break time taken (h)": c.breakTakenM > 0 ? h1(c.breakTakenM) : "",
          "Payroll hours (h)": s.sessions.length || s.payrollHours != null ? h1(c.payrollM) : "",
          "Potential OT (h)": c.potOtM > 0 ? h1(c.potOtM) : "",
          "OT approved": c.potOtM > 0 || s.payrollOtHours != null ? (s.overtimeApproved ? "Yes" : "No") : "",
          "Payroll o/time (h)": payrollOtM(s, c.potOtM) > 0 ? h1(payrollOtM(s, c.potOtM)) : (s.payrollOtHours != null ? s.payrollOtHours : ""),
          "Event reviewed": s.eventReviewed ? "Yes" : "",
          "Auto-confirmed": c.autoConf ? "Yes" : "",
          "Clock-in device(s)": [...new Set(s.sessions.map(x => x.inDevice).filter(Boolean))].join(", "),
          "Clock-out device(s)": [...new Set(s.sessions.map(x => x.outDevice).filter(Boolean))].join(", "),
          "Device changed": (s.deviceChangedIn || s.deviceChangedOut) ? "YES" : "",
          "Manager notes": s.reviewNotes || "",
          "Session notes": s.sessions.map(x => [x.inNotes, x.outNotes].filter(Boolean).join("; ")).filter(Boolean).join(" | ")
        });
      }
      if (!rows.length) continue;   // pharmacy has nothing under the selected roles
      sheets.push({
        name: ph.pharmacyName,
        headerLines: [`Pharmacy: ${ph.pharmacyName}`, `Clock in/out — day view`, dateLine, generatedStamp()],
        rows
      });
    }
    if (!sheets.length) sheets.push({ name: "No data", headerLines: [dateLine, generatedStamp()], rows: [{ Staff: "(no data for the selected roles)" }] });
    exportWorkbook(sheets, `clock_day_${date}.xlsx`);
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Date:</span>
          <input type="date" style={S.inp} value={date} onChange={e => setDate(e.target.value)} />
          <button style={{ ...S.btn("#6b7280"), padding: "4px 10px", fontSize: 12 }} onClick={() => setDate(todayStr())}>Today</button>
        </div>
        <RoleChecks roles={roles} active={activeRoles} setActive={setActiveRoles} />
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={() => load(date)}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        <button style={S.btn()} onClick={doExport}>⤓ Export to Excel</button>
      </div>
      <div style={{ marginBottom: 10 }}><Legend /></div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Loading {date}…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb", zIndex: 2 }}>Branch</th>
                {shownRoles.map(r => (
                  <th key={r} style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{r}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.pharmacies.map(ph => (
                <tr key={ph.dbName}>
                  <td style={{ padding: "6px 12px", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>
                    {ph.pharmacyName}
                    {ph.error && <div style={{ fontSize: 10, color: "#dc2626", fontWeight: 400 }}>load error</div>}
                  </td>
                  {shownRoles.map(role => {
                    const staff = ph.staff.filter(s => s.roleName === role);
                    return (
                      <td key={role} style={{ padding: "4px 6px", borderBottom: "1px solid #f1f5f9", borderLeft: "2px solid #f1f5f9", verticalAlign: "top" }}>
                        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                          {staff.map(s => {
                            const bg = cellStatus(date, s.planned, s.sessions, s.eventReviewed, new Date(), !!(s.deviceChangedIn || s.deviceChangedOut));
                            const tip = cellTooltip(s.planned, s.sessions, s.breaks, s.overtimeMins, date, s.eventReviewed, s.reviewNotes, { deviceChanged: !!(s.deviceChangedIn || s.deviceChangedOut) });
                            return (
                              <div key={s.staffId} title={(tip || s.staffName) + "\nDouble-click for the full analysis."}
                                onDoubleClick={() => {
                                  const dObj = new Date(date + "T00:00:00");
                                  setDlg({
                                    dbName: ph.dbName,
                                    entry: {
                                      staffId: s.staffId, staffName: s.staffName, date,
                                      weekday: dObj.getDay(), occurrence: Math.floor((dObj.getDate() - 1) / 7) + 1,
                                      planned: s.planned, sessions: s.sessions || [], breaks: s.breaks || [],
                                      overtimeMins: s.overtimeMins || 0, overtimeApproved: !!s.overtimeApproved,
                                      eventReviewed: !!s.eventReviewed, reviewNotes: s.reviewNotes || "",
                                      payrollHours: s.payrollHours != null ? s.payrollHours : null,
                                      payrollOtHours: s.payrollOtHours != null ? s.payrollOtHours : null,
                                      deviceChangedIn: !!s.deviceChangedIn, deviceChangedOut: !!s.deviceChangedOut,
                                      prevInDevice: s.prevInDevice || null, prevOutDevice: s.prevOutDevice || null,
                                      fourWeekContractedH: s.fourWeekContractedH != null ? s.fourWeekContractedH : null,
                                      roleName: s.roleName
                                    }
                                  });
                                }}
                                style={{ background: bg, border: "1px solid #d1d5db", borderRadius: 5, padding: "3px 8px", fontSize: 11.5, minWidth: 86, cursor: "pointer" }}>
                                <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 120,
                                               cursor: "pointer", textDecoration: "underline dotted", textUnderlineOffset: 3 }}
                                     title={`Click ${s.staffName}'s name to view and edit their weekly scheduled hours for the whole month (Mon–Sun pattern, break length and paid-break setting).`}
                                     onClick={e => { e.stopPropagation(); setSchedDlg({ dbName: ph.dbName, staffId: s.staffId, staffName: s.staffName, roleName: s.roleName }); }}
                                >{s.staffName}</div>
                                <div style={{ whiteSpace: "nowrap" }}>{sessionsText(s.sessions)}</div>
                                <div style={{ color: "#4b5563", whiteSpace: "nowrap" }}>
                                  {s.planned ? `(${s.planned.start || "?"}–${s.planned.end || "?"})` : "(no plan)"}
                                </div>
                              </div>
                            );
                          })}
                          {!staff.length && <span style={{ color: "#d1d5db", fontSize: 11 }}>—</span>}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {schedDlg && (
        <StaffScheduleDialog {...schedDlg} onReload={load} onClose={() => setSchedDlg(null)} />
      )}
      {dlg && (
        <CellDialog
          dbName={dlg.dbName}
          entry={dlg.entry}
          onClose={() => setDlg(null)}
          onReload={() => load(date)}
          onLocalPatch={(fields) => {
            setDlg(d2 => d2 ? { ...d2, entry: { ...d2.entry, ...fields } } : d2);
            setData(prev => {
              if (!prev) return prev;
              return { ...prev, pharmacies: prev.pharmacies.map(p2 =>
                p2.dbName !== dlg.dbName ? p2 : { ...p2, staff: p2.staff.map(s2 =>
                  s2.staffId !== dlg.entry.staffId ? s2 : { ...s2, ...fields }) }) };
            });
          }}
        />
      )}
    </div>
  );
}

/* ============================================================================
   TAB 2 — Month view: one pharmacy, editable planned hours, totals
   ============================================================================ */
function MonthTab({ pharmacies }) {
  const now = new Date();
  const [dbName, setDbName] = useState("");
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [activeRoles, setActiveRoles] = useState(new Set());
  const [edit, setEdit] = useState(null); // full CellDialog entry built from the clicked cell
  const [schedDlg, setSchedDlg] = useState(null); // weekly schedule editor (name click)
  const [phStatus, setPhStatus] = useState({});   // dbName -> 'green'|'red'|'none' (dropdown colouring)
  const [exportingAll, setExportingAll] = useState(false);

  // Dropdown colouring: per-pharmacy month status (green = every populated
  // cell approved manually or auto; red = any red cell; none otherwise).
  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const d = await post("/api/headoffice/clock/month/status", { year, month });
        if (!dead) setPhStatus(d.statuses || {});
      } catch (_) { if (!dead) setPhStatus({}); }
    })();
    return () => { dead = true; };
  }, [year, month]);

  useEffect(() => { if (!dbName && pharmacies.length) setDbName(pharmacies[0].dbName); }, [pharmacies, dbName]);

  const load = useCallback(async () => {
    if (!dbName) return;
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/month", { dbName, year, month });
      setData(res);
      const roles = [...new Set(res.staff.map(s => s.roleName))];
      setActiveRoles(new Set(roles));
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, [dbName, year, month]);
  useEffect(() => { load(); }, [load]);

  const roles = useMemo(() => [...new Set((data?.staff || []).map(s => s.roleName))].sort(), [data]);
  const staffShown = (data?.staff || []).filter(s => activeRoles.has(s.roleName));

  // Column totals under the NEW payroll arithmetic (dayCalc): planned
  // (contracted) hours, actual payroll hours (stored override or net actual
  // capped at paid contracted), and overtime — the net-rule surplus of
  // APPROVED (ticked) days only.
  const colTotals = (staffId) => {
    const m = data?.cells?.[staffId] || {};
    let rawM = 0, plannedM = 0, payrollM = 0, otApprovedM = 0;
    for (const k of Object.keys(m)) {
      const c = dayCalc(k, m[k]);
      rawM += c.actualM;           // raw = every session's out minus in
      plannedM += c.contractedM;
      payrollM += c.payrollM;
      otApprovedM += payrollOtM(m[k], c.potOtM);
    }
    return { rawH: h1(rawM), plannedH: h1(plannedM), payrollH: h1(payrollM), overtimeH: h1(otApprovedM) };
  };

  // Build + save one workbook (tab per staff member) for a month payload —
  // used by both the single-pharmacy export and "Export all pharmacies".
  const exportMonthWorkbook = (mData, phName, staffList) => {
    // One TAB PER STAFF MEMBER; each day is a row with the parameters
    // separated into their own columns — Contracted / Actual / Breaks /
    // Overtime / Overtime approved / Notes — and a Totals bottom row.
    const sheets = staffList.map(s => {
      const cellsFor = mData.cells[s.staffId] || {};
      let plannedTotM = 0, payrollTotM = 0, otApprovedTotM = 0, onSiteTotM = 0, breakTotM = 0;
      const rows = mData.days.map(d => {
        const c = cellsFor[d.date];
        const k = dayCalc(d.date, c);
        plannedTotM += k.contractedM; payrollTotM += k.payrollM;
        onSiteTotM += k.actualM; breakTotM += k.breakTakenM;
        otApprovedTotM += payrollOtM(c, k.potOtM);
        const hasClock = !!c?.sessions?.length;
        return {
          Day: `${d.day} ${WEEKDAYS[d.weekday]}`,
          Contracted: c?.planned ? `${c.planned.start || "?"}–${c.planned.end || "?"}` : "",
          "Raw hours on site (h)": hasClock ? h1(k.actualM) : "",
          "Hours to be on site (h)": k.contractedM > 0 ? h1(k.contractedM) : "",
          "Break entitlement (h)": k.breakEntM > 0 ? h1(k.breakEntM) : "",
          "Breaks paid": c?.planned ? (k.breaksPaid ? "Yes" : "No") : "",
          "Paid contracted (h)": k.paidContractedM > 0 ? h1(k.paidContractedM) : "",
          Actual: hasClock ? sessionsText(c.sessions) : "",
          "Distance in (m)": (c?.sessions || []).map(x => x.distIn != null ? x.distIn : "").filter(x => x !== "").join(", "),
          "Distance out (m)": (c?.sessions || []).map(x => x.distOut != null ? x.distOut : "").filter(x => x !== "").join(", "),
          ">50m flag": anyFar(c?.sessions) ? "YES" : "",
          Breaks: (c?.breaks || []).map(b => `${hm(b.start)}–${b.end ? hm(b.end) : "…"} (${b.mins || 0}m)`).join(", "),
          "Break time taken (h)": k.breakTakenM > 0 ? h1(k.breakTakenM) : "",
          "Payroll hours (h)": hasClock || c?.payrollHours != null ? h1(k.payrollM) : "",
          "Potential OT (h)": k.potOtM > 0 ? h1(k.potOtM) : "",
          "OT approved": k.potOtM > 0 || c?.payrollOtHours != null ? (c?.overtimeApproved ? "Yes" : "No") : "",
          "Payroll o/time (h)": payrollOtM(c, k.potOtM) > 0 ? h1(payrollOtM(c, k.potOtM)) : (c?.payrollOtHours != null ? c.payrollOtHours : ""),
          "Event reviewed": c?.eventReviewed ? "Yes" : "",
          "Auto-confirmed": k.autoConf ? "Yes" : "",
          "Clock-in device(s)": [...new Set((c?.sessions || []).map(x => x.inDevice).filter(Boolean))].join(", "),
          "Clock-out device(s)": [...new Set((c?.sessions || []).map(x => x.outDevice).filter(Boolean))].join(", "),
          "Device changed": (c?.deviceChangedIn || c?.deviceChangedOut) ? "YES" : "",
          "Manager notes": c?.reviewNotes || "",
          "Session notes": (c?.sessions || []).map(x => [x.inNotes, x.outNotes].filter(Boolean).join("; ")).filter(Boolean).join(" | ")
        };
      });
      rows.push({
        Day: "TOTALS",
        Contracted: "",
        "Raw hours on site (h)": h1(onSiteTotM),
        "Hours to be on site (h)": `${h1(plannedTotM)} planned`,
        "Break entitlement (h)": "",
        "Breaks paid": "",
        "Paid contracted (h)": "",
        Actual: "",
        "Distance in (m)": "",
        "Distance out (m)": "",
        ">50m flag": "",
        Breaks: "",
        "Break time taken (h)": h1(breakTotM),
        "Payroll hours (h)": h1(payrollTotM),
        "Potential OT (h)": "",
        "OT approved": "",
        "Payroll o/time (h)": h1(otApprovedTotM),
        "Event reviewed": "",
        "Auto-confirmed": "",
        "Clock-in device(s)": "",
        "Clock-out device(s)": "",
        "Device changed": "",
        "Manager notes": "",
        "Session notes": ""
      });
      return {
        name: s.staffName,
        headerLines: [
          `Pharmacy: ${phName}`,
          `Staff: ${s.staffName} (${s.roleName})`,
          `Four week contracted hours total: ${s.fourWeekContractedH != null ? s.fourWeekContractedH.toFixed(2) : "—"}h`,
          `Clock in/out — month view: ${MONTHS[month - 1]} ${year}`,
          generatedStamp()
        ],
        rows
      };
    });
    if (!sheets.length) sheets.push({ name: "No data", headerLines: [generatedStamp()], rows: [{ Day: "(no staff for the selected roles)" }] });
    exportWorkbook(sheets, `clock_month_${(phName).replace(/[^\w]+/g, "_")}_${year}-${String(month).padStart(2, "0")}.xlsx`);
  };

  const doExport = () => {
    if (!data) return;
    const ph = pharmacies.find(p => p.dbName === dbName);
    exportMonthWorkbook(data, ph?.pharmacyName || dbName, staffShown);
  };

  // One spreadsheet PER PHARMACY for the selected month — fetches each
  // pharmacy's month in turn and saves a separate workbook (all roles).
  const exportAll = async () => {
    if (exportingAll) return;
    setExportingAll(true); setErr(null);
    try {
      for (const p of pharmacies) {
        try {
          const d = await post("/api/headoffice/clock/month", { dbName: p.dbName, year, month });
          if ((d.staff || []).length) exportMonthWorkbook(d, p.pharmacyName, d.staff);
        } catch (e) { console.error("export all:", p.pharmacyName, e.message); }
      }
    } finally { setExportingAll(false); }
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Pharmacy:</span>
          <select style={{ ...S.inp, maxWidth: 260 }} value={dbName} onChange={e => setDbName(e.target.value)}
            title="Green: every recorded day this month is approved (manually or auto-confirmed). Red: at least one day needs attention. No colour: nothing recorded, or a mix awaiting completion.">
            {pharmacies.map(p => {
              const st = phStatus[p.dbName];
              const bg = st === "green" ? "#bbf7d0" : st === "red" ? "#fecaca" : undefined;
              return <option key={p.dbName} value={p.dbName} style={bg ? { background: bg } : undefined}>{p.pharmacyName}</option>;
            })}
          </select>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Month:</span>
          <select style={S.inp} value={month} onChange={e => setMonth(Number(e.target.value))}>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
          <select style={S.inp} value={year} onChange={e => setYear(Number(e.target.value))}>
            {Array.from({ length: 4 }, (_, i) => now.getFullYear() - 2 + i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <RoleChecks roles={roles} active={activeRoles} setActive={setActiveRoles} />
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={load}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        <button style={S.btn()} onClick={doExport}>⤓ Export to Excel</button>
        <button style={S.btn("#3730a3")} disabled={exportingAll} onClick={exportAll}
          title="Downloads one workbook per pharmacy for the selected month — every staff member of every role, one tab each.">
          {exportingAll ? "Exporting…" : "⤓ Export all pharmacies"}
        </button>
      </div>
      <div style={{ marginBottom: 8 }}><Legend /></div>
      <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>
        Click any cell to set that staff member's planned start/end for that weekday pattern (e.g. every 2nd Friday, or all Fridays) — stored per weekday-occurrence in staff_times.
      </div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Loading month…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff", maxHeight: "68vh", overflowY: "auto" }}>
          <table style={{ borderCollapse: "collapse" }}>
            <thead>
              {/* role group header over the staff columns */}
              <tr style={{ background: "#f3f4f6", position: "sticky", top: 0, zIndex: 3 }}>
                <th style={{ position: "sticky", left: 0, background: "#f3f4f6", zIndex: 4 }} />
                {(() => {
                  const groups = [];
                  for (const s of staffShown) {
                    const last = groups[groups.length - 1];
                    if (last && last.role === s.roleName) last.count++;
                    else groups.push({ role: s.roleName, count: 1 });
                  }
                  return groups.map((g, i) => (
                    <th key={`${g.role}-${i}`} colSpan={g.count}
                      style={{ ...S.lab, padding: "4px 8px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{g.role}</th>
                  ));
                })()}
              </tr>
              <tr style={{ background: "#f9fafb", position: "sticky", top: 25, zIndex: 3 }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "6px 10px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb", zIndex: 4, minWidth: 74 }}>Day</th>
                {staffShown.map((s, i) => {
                  // all of this member's review-needing days reviewed (manual or auto)?
                  let rNeed = 0, rDone = 0;
                  const cm = data.cells[s.staffId] || {};
                  for (const dd of data.days) {
                    const cc = cm[dd.date] || {};
                    if (!(cc.sessions || []).length && !cc.planned) continue;
                    rNeed++;
                    if (cc.eventReviewed || dayCalc(dd.date, cc).autoConf) rDone++;
                  }
                  const allRev = rNeed > 0 && rDone === rNeed;
                  return (
                  <th key={s.staffId} style={{ ...S.lab, padding: "4px 6px", borderBottom: "1px solid #e5e7eb", minWidth: 92, maxWidth: 130,
                      background: allRev ? "#dcfce7" : undefined,
                      borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}
                      title={allRev ? `Every one of ${s.staffName}'s days needing review this month is reviewed (manually or automatically).` : undefined}>
                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: 120,
                                   cursor: "pointer", textDecoration: "underline dotted", textUnderlineOffset: 3,
                                   color: allRev ? "#15803d" : undefined }}
                          title={`Click ${s.staffName}'s name to view and edit their weekly scheduled hours for the whole month (Mon–Sun pattern, break length and paid-break setting).`}
                          onClick={() => setSchedDlg({ dbName, staffId: s.staffId, staffName: s.staffName, roleName: s.roleName })}
                    >{s.staffName}</span>
                  </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data.days.map(d => (
                <tr key={d.date} style={{ background: (d.weekday === 0 || d.weekday === 6) ? C.off : undefined }}>
                  <td style={{ padding: "4px 10px", fontSize: 12, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: (d.weekday === 0 || d.weekday === 6) ? "#f3f4f6" : "#fff", zIndex: 1, fontWeight: 700 }}>
                    {d.day} <span style={{ fontWeight: 400, color: "#6b7280" }}>{WEEKDAYS[d.weekday]}</span>
                  </td>
                  {staffShown.map((s, i) => {
                    const c = data.cells[s.staffId]?.[d.date];
                    const planned = c?.planned || null;
                    const sessions = c?.sessions || [];
                    const breaks = c?.breaks || [];
                    const otM = c?.overtimeMins || 0;
                    const st = cellStatus(d.date, planned, sessions, c?.eventReviewed, new Date(), !!(c?.deviceChangedIn || c?.deviceChangedOut));
                    const bg = st === C.blank ? "transparent" : st;
                    const tip = cellTooltip(planned, sessions, breaks, otM, d.date, c?.eventReviewed, c?.reviewNotes, { deviceChanged: !!(c?.deviceChangedIn || c?.deviceChangedOut) });
                    const brkM = breaks.reduce((tt, b) => tt + (b.mins || 0), 0);
                    return (
                      <td key={s.staffId} title={tip}
                        onClick={() => setEdit({
                          staffId: s.staffId, staffName: s.staffName, date: d.date,
                          weekday: d.weekday, occurrence: Math.floor((d.day - 1) / 7) + 1,
                          planned, sessions, breaks,
                          overtimeMins: otM, overtimeApproved: !!c?.overtimeApproved,
                          eventReviewed: !!c?.eventReviewed, reviewNotes: c?.reviewNotes || "",
                          payrollHours: c?.payrollHours != null ? c.payrollHours : null,
                          payrollOtHours: c?.payrollOtHours != null ? c.payrollOtHours : null,
                          deviceChangedIn: !!c?.deviceChangedIn, deviceChangedOut: !!c?.deviceChangedOut,
                          prevInDevice: c?.prevInDevice || null, prevOutDevice: c?.prevOutDevice || null,
                          fourWeekContractedH: s.fourWeekContractedH != null ? s.fourWeekContractedH : null,
                          roleName: s.roleName
                        })}
                        style={{ background: bg, border: "1px solid #f1f5f9",
                                 padding: "2px 3px", fontSize: 10.5, textAlign: "center", cursor: "pointer", verticalAlign: "top",
                                 borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                        <div style={{ whiteSpace: "nowrap", fontWeight: 600 }}>{sessions.length ? sessionsText(sessions) : ""}</div>
                        <div style={{ color: "#4b5563", whiteSpace: "nowrap" }}>{planned ? `(${planned.start || "?"}–${planned.end || "?"})` : ""}</div>
                        {brkM > 0 && <div style={{ color: "#7c3aed", whiteSpace: "nowrap" }}>brk {brkM}m</div>}
                        {otM > 0 && (
                          <div style={{ color: "#1d4ed8", fontWeight: 700, whiteSpace: "nowrap" }}>
                            OT {Math.round(otM / 0.6) / 100}h {c?.overtimeApproved ? "☑" : "☐"}
                          </div>
                        )}
                        {c?.eventReviewed && <div style={{ color: "#1e40af", fontWeight: 700 }}>✔ reviewed</div>}
                        {(sessions.some(x => x.inNotes || x.outNotes)) && <div style={{ color: "#0f766e" }}>✎</div>}
                      </td>
                    );
                  })}
                </tr>
              ))}
              {/* totals rows — one per measure, per staff column; STICKY at the
                  bottom of the scroll area (fixed 24px rows, stacked offsets)
                  so the day cells scroll between the header and these totals */}
              {[["rawH", "Raw hours on site:"], ["plannedH", "Planned hrs total:"], ["payrollH", "Actual payroll hours total:"], ["overtimeH", "Overtime total:"]].map(([f, label], ri) => {
                const stickBottom = (3 - ri) * 24;
                const totCell = { position: "sticky", bottom: stickBottom, background: "#f9fafb",
                                  height: 24, boxSizing: "border-box", zIndex: 2,
                                  borderTop: ri === 0 ? "2px solid #e5e7eb" : "1px solid #f1f5f9" };
                return (
                <tr key={f}>
                  <td style={{ ...S.lab, ...totCell, padding: "4px 10px", whiteSpace: "nowrap", left: 0, zIndex: 3 }}
                      title={f === "overtimeH" ? "Sum of APPROVED (ticked) overtime only — the manual payroll o/time override where set, otherwise the net-rule surplus over paid contracted hours."
                        : f === "payrollH" ? "Sum of each day's payroll hours: the manual override where set, otherwise net hours on site capped at paid contracted."
                        : f === "rawH" ? "Every session's clock out minus clock in, summed — no break or contract adjustments." : undefined}>{label}</td>
                  {staffShown.map((s, i) => (
                    <td key={s.staffId} style={{ ...totCell, padding: "3px 6px", fontSize: 11.5, textAlign: "center", fontWeight: 700,
                        color: f === "overtimeH" ? "#1d4ed8" : undefined,
                        borderLeft: (i === 0 || staffShown[i - 1].roleName !== s.roleName) ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                      {colTotals(s.staffId)[f]}
                    </td>
                  ))}
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {schedDlg && (
        <StaffScheduleDialog {...schedDlg} onReload={load} onClose={() => setSchedDlg(null)}
          monthDays={data?.days || []}
          cellsForStaff={data?.cells?.[schedDlg.staffId] || {}}
          monthLabel={`${MONTHS[month - 1]} ${year}`}
          fourWeekContractedH={(data?.staff || []).find(s => s.staffId === schedDlg.staffId)?.fourWeekContractedH ?? null}
          onCellPatch={(date, fields) => {
            setData(prev => {
              if (!prev) return prev;
              const cur = prev.cells?.[schedDlg.staffId]?.[date] || {};
              return { ...prev, cells: { ...prev.cells, [schedDlg.staffId]: { ...(prev.cells[schedDlg.staffId] || {}),
                [date]: { ...cur, ...fields } } } };
            });
          }}
        />
      )}
      {edit && (
        <CellDialog
          dbName={dbName}
          entry={edit}
          onClose={() => setEdit(null)}
          onReload={load}
          onLocalPatch={(fields) => {
            setEdit(e2 => ({ ...e2, ...fields }));
            setData(prev => {
              if (!prev) return prev;
              const cur = prev.cells?.[edit.staffId]?.[edit.date] || { planned: edit.planned, sessions: edit.sessions, breaks: edit.breaks, overtimeMins: edit.overtimeMins };
              return { ...prev, cells: { ...prev.cells, [edit.staffId]: { ...(prev.cells[edit.staffId] || {}),
                [edit.date]: { ...cur, ...fields } } } };
            });
          }}
        />
      )}
    </div>
  );
}

/* ============================================================================
   TAB 3 — Summary: pharmacy x role totals
   ============================================================================ */
function SummaryTab() {
  const now = new Date();
  const [year, setYear] = useState(String(now.getFullYear()));
  const [month, setMonth] = useState("");
  const [measures, setMeasures] = useState({ contracted: true, onSite: true, payroll: true, overtime: true });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const load = useCallback(async () => {
    setLoading(true); setErr(null);
    try {
      const res = await post("/api/headoffice/clock/summary", {
        year: year ? Number(year) : null, month: month ? Number(month) : null
      });
      setData(res);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  }, [year, month]);
  useEffect(() => { load(); }, [load]);

  const shown = [
    measures.contracted && ["contractedH", "Contracted"],
    measures.onSite && ["onSiteH", "On site"],
    measures.payroll && ["payrollH", "Payroll"],
    measures.overtime && ["overtimeH", "Overtime (ticked)"]
  ].filter(Boolean);
  // The three bottom totals rows: label + which measure column they sum.
  const TOTAL_ROWS = [
    ["Raw hours on site:", "onSiteH"],
    ["Planned hrs total:", "contractedH"],
    ["Actual payroll hours total:", "payrollH"],
    ["Overtime total:", "overtimeH"]
  ];
  const colSum = (role, field) => {
    let sum = 0;
    for (const [, roleMap] of byPharmacy) { const r = roleMap[role]; if (r) sum += (r[field] || 0); }
    return Math.round(sum * 10) / 10;
  };

  const byPharmacy = useMemo(() => {
    const map = new Map();
    for (const r of (data?.rows || [])) {
      if (!map.has(r.pharmacyName)) map.set(r.pharmacyName, {});
      map.get(r.pharmacyName)[r.roleName] = r;
    }
    return map;
  }, [data]);
  const roles = data?.roles || [];

  const windowLabel = year && month ? `${MONTHS[Number(month) - 1]} ${year}` : year ? `${year} (all months)` : month ? `${MONTHS[Number(month) - 1]} (all years)` : "All time";

  const doExport = () => {
    if (!data) return;
    const rows = [];
    for (const [ph, roleMap] of byPharmacy) {
      const row = { Pharmacy: ph };
      for (const role of roles) {
        const r = roleMap[role];
        for (const [field, label] of shown) row[`${role} — ${label} (h)`] = r ? r[field] : 0;
      }
      rows.push(row);
    }
    if (rows.length) {
      for (const [tLabel, tField] of TOTAL_ROWS) {
        const totalsRow = { Pharmacy: tLabel };
        for (const role of roles) for (const [field, label] of shown) {
          totalsRow[`${role} — ${label} (h)`] = field === tField ? colSum(role, tField) : "";
        }
        rows.push(totalsRow);
      }
    }
    exportSheet(rows.length ? rows : [{ Pharmacy: "(no data)" }], windowLabel.slice(0, 31),
      `clock_summary_${(year || "all")}-${(month || "all")}.xlsx`, [
      `${orgLine() ? orgLine() + " — " : ""}Clock in/out — summary (pharmacy × role)`,
      `Window: ${windowLabel}`,
      generatedStamp()
    ]);
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={S.lab}>Year:</span>
          <select style={S.inp} value={year} onChange={e => setYear(e.target.value)}>
            <option value="">All years</option>
            {Array.from({ length: 4 }, (_, i) => now.getFullYear() - 3 + i + 1).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <span style={S.lab}>Month:</span>
          <select style={S.inp} value={month} onChange={e => setMonth(e.target.value)}>
            <option value="">All months</option>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <span style={S.lab}>Show:</span>
          {[["contracted", "Contracted hours"], ["onSite", "Hours on site"], ["overtime", "Overtime (ticked)"]].map(([k, label]) => (
            <label key={k} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, cursor: "pointer" }}>
              <input type="checkbox" checked={measures[k]} onChange={e => setMeasures(m => ({ ...m, [k]: e.target.checked }))} />
              {label}
            </label>
          ))}
        </div>
        <button style={{ ...S.btn("#0f766e"), marginLeft: "auto" }} disabled={loading} onClick={load}>
          {loading ? "Refreshing…" : "↻ Refresh now"}</button>
        <button style={S.btn()} onClick={doExport}>⤓ Export to Excel</button>
      </div>
      <div style={{ fontSize: 12.5, color: "#374151", marginBottom: 8 }}>
        Window: <b>{windowLabel}</b> · <b style={{ color: "#1d4ed8" }}>Overtime shows CONFIRMED overtime only</b> — cells
        ticked as approved on the month view's day analysis. Unticked overtime is not counted here.
      </div>
      {err && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>Error: {err}</div>}
      {loading && <div style={{ color: "#6b7280", fontSize: 13, padding: 12 }}>Computing summary…</div>}
      {!loading && data && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                <th style={{ ...S.lab, textAlign: "left", padding: "8px 12px", borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb" }}>Pharmacy</th>
                {roles.map(role => (
                  <th key={role} colSpan={shown.length} style={{ ...S.lab, padding: "6px 8px", borderBottom: "1px solid #e5e7eb", borderLeft: "2px solid #e5e7eb" }}>{role}</th>
                ))}
              </tr>
              {shown.length > 1 && (
                <tr style={{ background: "#f9fafb" }}>
                  <th style={{ borderBottom: "1px solid #e5e7eb", position: "sticky", left: 0, background: "#f9fafb" }} />
                  {roles.map(role => shown.map(([f, label]) => (
                    <th key={`${role}-${f}`} style={{ fontSize: 10, color: "#6b7280", padding: "2px 6px", borderBottom: "1px solid #e5e7eb", borderLeft: f === shown[0][0] ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>{label}</th>
                  )))}
                </tr>
              )}
            </thead>
            <tbody>
              {[...byPharmacy.entries()].map(([ph, roleMap]) => (
                <tr key={ph}>
                  <td style={{ padding: "6px 12px", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", position: "sticky", left: 0, background: "#fff" }}>{ph}</td>
                  {roles.map(role => shown.map(([f], fi) => {
                    const r = roleMap[role];
                    return (
                      <td key={`${role}-${f}`} style={{ padding: "6px 8px", fontSize: 12.5, textAlign: "center", whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9", borderLeft: fi === 0 ? "2px solid #f1f5f9" : "1px solid #f8fafc" }}>
                        {r ? `${r[f]}h` : "—"}
                      </td>
                    );
                  }))}
                </tr>
              ))}
              {byPharmacy.size > 0 && TOTAL_ROWS.map(([label, field], ri) => (
                <tr key={label} style={{ background: "#f9fafb", borderTop: ri === 0 ? "2px solid #e5e7eb" : undefined }}>
                  <td style={{ ...S.lab, padding: "5px 12px", whiteSpace: "nowrap", position: "sticky", left: 0, background: "#f9fafb" }}>{label}</td>
                  {roles.map(role => shown.map(([f], fi) => (
                    <td key={`t-${label}-${role}-${f}`} style={{ padding: "5px 8px", fontSize: 12.5, fontWeight: 800, textAlign: "center", whiteSpace: "nowrap", borderLeft: fi === 0 ? "2px solid #e5e7eb" : "1px solid #f1f5f9" }}>
                      {f === field ? `${colSum(role, field)}h` : ""}
                    </td>
                  )))}
                </tr>
              ))}
              {!byPharmacy.size && (
                <tr><td colSpan={1 + roles.length * shown.length} style={{ padding: 20, textAlign: "center", color: "#6b7280", fontSize: 13 }}>No clock data in this window.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

/* ============================================================================
   Panel shell
   ============================================================================ */
export default function ClockInOut() {
  const [tab, setTab] = useState(0);
  const [pharmacies, setPharmacies] = useState([]);
  useEffect(() => {
    // pharmacy list for the month tab's selector: reuse the day endpoint's
    // scoped members via a lightweight call for today (names only needed)
    post("/api/headoffice/clock/day", { date: todayStr() })
      .then(d => setPharmacies((d.pharmacies || []).map(p => ({ pharmacyName: p.pharmacyName, dbName: p.dbName }))))
      .catch(() => {});
  }, []);

  const TABS = ["Day view — all branches", "Month view — one branch", "Summary", "Workforce planner", "Raw data", "Pharmacist rota"];
  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", color: "#111" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontSize: 20, color: "#0f766e" }}>Staffing</h2>
        {/* Segmented control: three abutting buttons, selected one filled */}
        <div style={{ display: "inline-flex", border: "1px solid #0f766e", borderRadius: 6, overflow: "hidden" }}>
          {TABS.map((t, i) => (
            <button key={t} onClick={() => setTab(i)}
              style={{
                border: "none",
                borderLeft: i > 0 ? "1px solid #0f766e" : "none",
                background: tab === i ? "#0f766e" : "#fff",
                color: tab === i ? "#fff" : "#0f766e",
                padding: "7px 16px", fontSize: 13.5,
                fontWeight: tab === i ? 800 : 600,
                cursor: "pointer", fontFamily: "inherit"
              }}>
              {t}
            </button>
          ))}
        </div>
      </div>
      {tab === 0 && <DayTab />}
      {tab === 1 && <MonthTab pharmacies={pharmacies} />}
      {tab === 2 && <SummaryTab />}
      {/* Moved in from the left menu (Staff flyout) — same components,
          same logic, now living as tabs in this panel. Workforce gets the
          organisation's real pharmacy names in place of its placeholders. */}
      {tab === 3 && <Workforce />}
      {tab === 4 && <Stafflogin />}
      {tab === 5 && <PharmacistRota />}
    </div>
  );
}